import {DownloadType} from '@/enum/download_type';

const heading = 'nadpis';
const paragraph = 'odstavec';

export default {
    hello: 'Ahoj!',
    and: 'a',
    or: 'nebo',
    continue: 'Pokračovat',
    close: 'Zavřít',
    cancel: 'Zrušit',
    yearWeek: '{1}. týden roku {0}',
    unexpectedError: 'Došlo k neočekávané chybě, zkuste prosím akci opakovat.',
    createdBy: "Vytvořeno v nástroji SEOWRITEE",
    affiliate: "Registrujte se do našeho affiliate programu a získejte finanční odměnu za Vámi získáné zákazníky!",
    unknownError: "Nastala neočekávaná chyba!",

    profile: {
        title: 'Váš účet',
        upgradeTitle: 'Přejít na vyšší tarif',
        upgradeSubtitle: 'Tarif můžete kdykoli zvýšit. Zbývající období vyúčtuje Stripe.',
        articlesTotal: 'Články v knihovně',
        articlesThisPeriod: 'Toto zúčtovací období',
        avgSeo: 'Průměrné SEO skóre',
        bestSeo: 'Nejlepší SEO skóre',
        generated: 'Napsané AI',
        analyzed: 'Analyzované z URL',
        published: 'Se zveřejněnou URL',
        extraCredits: 'Extra kredity',
        freeAnalyses: 'Analýzy zdarma tento měsíc',
        freeAnalysesHint: 'Zbývají {0} z {1}. Každá analýza článku z URL spotřebuje 1. Obnoví se 1. dne v měsíci. Generování nových článků AI vyžaduje placený tarif.',
        recent: 'Poslední články',
        noArticles: 'Zatím jste nevytvořili žádný článek.',
        loadingStats: 'Načítám statistiky…',
        statsError: 'Statistiky článků se nepodařilo načíst.',
        statsSample: 'Průměry jsou z vašich {0} nejnovějších článků.',
        openArticle: 'Otevřít',
        noScore: '—',
        typeGenerate: 'Generovat',
        typeAnalyze: 'Analýza',
        firstArticle: 'První článek',
        seeAllArticles: 'Všechny články',
    },

    save: 'Uložit',
    delete: 'Smazat',
    settings: 'Nastavení',
    languageSelector: {
        label: 'Jazyk',
        cs: 'Čeština',
        en: 'English',
    },

    subscriptions: {
        title: 'Aplikace je vám nyní připravena napsat kompletně celý článek skvěle optimalizovaný pro internetové vyhledávače a atraktivní pro čtenáře.',
        subTitle: 'Vyberte si tarif, zaplaťe online a začněte okamžitě generovat kvalitní SEO obsah.',
        pricingTitle: 'Tarify',
        pricingSubtitle: 'Každý tarif zahrnuje AI psaní, SEO skóre a analýzu klíčových slov. Vyberte objem podle toho, jak často publikujete.',
        currentPlan: 'Váš aktuální tarif',
        popular: 'Oblíbený',
        getStarted: 'Vybrat tarif',
        startFree: 'Začít zdarma',
        contactSales: 'Kontaktovat',
        faqTitle: 'Často kladené otázky',
        faqChangeQ: 'Mohu tarif kdykoli změnit nebo zrušit?',
        faqIncludedQ: 'Co je součástí každého tarifu?',
        faqBusinessQ: 'Nabízíte individuální Business tarif?',
        affiliateTitle: 'Vydělejte se SEOWRITEE',
        affiliateCta: 'Zapojit se do affiliate programu',
        oneTimeSubtitle: 'Potřebujete tento měsíc extra články, aniž byste měnili tarif?',
        mustAcceptTerms: 'Než budete pokračovat, přijměte obchodní podmínky.',
        manageBilling: 'Spravovat platby',
        perMonthShort: 'měsíčně',
        changePlanCta: 'Změnit tarif',

        perMonth: '{0} / měsíc',
        inspiration: 'články',
        upToInspirations: '{0} články měsíčně',
        keywords: '{0} klíčových slov ve 4 skupinách',
        buy: 'Koupit',

        allPlansInclude: 'Všechny tarify obsahují',
        mustChoosePlan: 'Musíte zvolit preferovaný tarif!',
        continueWithPlan: 'Pokračovat s \'{0}\'',
        noPlan: 'předplatné neaktivní',
        activePlan: 'aktivní',
        changePlan: 'změnit',
        choosePlan: 'vybrat',
        chosenPlan: 'vybráno',
        usageTooltip: 'Máte vytvořeno {0} z {1} článků pro toto období',
        unlimitedUsageTooltip: 'V tomto období máte vytvořeno {0} článků',
        planRenewTooltip: 'Počítadlo se obnoví',
        planWillBeCancelled: 'Vaše předplatné bude ukončeno',
        noInspirationsLeftThisPeriodUpgradeToContinue: {
            title: 'Vyčerpali jste všechny články!',
            content: 'V tomto období jste již použili všechny dostupné články. Pro pokračování přejděte na vyšší tarif nebo zakupte jednorázový balíček článků.',
            action: 'Zobrazit tarify'
        },
        manageSubscription: 'Spravovat nebo změnit tarif či fakturační údaje',
        oneTimePacks: 'Jednorázové balíčky článků',

        usage: {
            freeAnalyses: '{0} z {1} bezplatných analýz zbývá tento měsíc',
            freeAnalysesReset: 'Obnoví se 1. dne každého měsíce',
            freeAnalysesExplain: 'Na bezplatném tarifu máte každý kalendářní měsíc {max} analýz existujícího článku z URL. Tento měsíc už máte {used} a zbývají {left}. Generování nových článků AI je v placeném tarifu.',
            freeAnalysesNone: 'Tento měsíc už nemáte žádnou bezplatnou analýzu. Další dostanete 1. dne příštího měsíce, nebo si aktivujte tarif.',
            articlesRemaining: '{0} z {1} článků zbývá v tomto období',
            unlimitedArticles: '{0} článků vytvořeno v tomto období',
            warningLimitReached: 'Varování: Dosáhli jste {0} článků - blížíte se měsíčnímu limitu',
            usingExtraInspirations: 'Měsíční limit dosažen - nyní se používají extra kredity',
            extraInspirationsExplain: 'Máte {0} extra kreditů pro generování obsahu',
            extraInspirationsAfterPlan: '{0} extra kreditů k dispozici',
            extraInspirationsAfterLimit: '{0} extra kreditů může být použito po {1} článcích',
            extraInspirationsAvailable: '{0} extra kreditů zbývá'
        },
        barLabel: 'Čerpání tarifu',
        barLabelFree: 'Analýzy zdarma',
        barTooltip: 'Profil a čerpání tarifu',
        usageLoading: 'Načítám tarif',
        usageLoadingTooltip: 'AI Lucy načítá váš tarif. Čerpání se ukáže, až bude tarif známý.',

        freeAnalyses: {
            title: '{0} Analýzy zdarma měsíčně',
            description: 'Analyzujte svůj existující obsah a vylepšete SEO skóre',
            remaining: '{0} z {1} analýz zbývá tento měsíc',
            exhausted: {
                title: 'Již nemáte žádné analýzy tento měsíc',
                content: 'Využili jste všechny {0} bezplatné analýzy pro tento měsíc. Přejděte na vyšší tarif a pokračujte v analýze a generování obsahu!',
                action: 'Přejít na vyšší tarif'
            },
            resetsOn: 'Obnoví se 1. dne každého měsíce'
        },

        paywall: {
            generateRequiresPlan: {
                title: 'Aktivujte tarif pro generování obsahu',
                content: 'Pro generování SEO článků pomocí AI je potřeba aktivní předplatné. Vyberte si tarif a začněte vytvářet kvalitní obsah již dnes!',
                action: 'Vybrat tarif'
            },
            polishRequiresPlan: {
                title: 'Přejděte na vyšší tarif pro vylepšení obsahu',
                content: 'AI vylepšení obsahu je dostupné pro předplatitele. Přejděte na vyšší tarif a vylepšete své články!',
                action: 'Zobrazit tarify'
            },
            enhanceRequiresPlan: {
                title: 'Přejděte na vyšší tarif pro vylepšení obsahu',
                content: 'AI vylepšení obsahu je dostupné pro předplatitele. Přejděte na vyšší tarif a vylepšete své články!',
                action: 'Zobrazit tarify'
            }
        },

        upgradeToBusiness: {
            title: 'Přejít na Business tarif',
            content: 'Dosáhli jste limitu pro intenzivní spisovatele ({0} článků). Zvažte přechod na náš Business tarif pro lepší podmínky!',
            action: 'Přejít na Business',
        },

        free: 'zdarma',
        individual: 'individuální',
        individualContact: 'Domluvíme se s vámi na individuální ceně. Kontaktujte nás prosím na email rudolf.sehnal@seowritee.com',

        features: {
            aiWriting: 'Až několik set tisíc slov napsaných umělou inteligencí',
            seoScore: 'SEO skóre vypočítané z 20+ parametrů',
            instructions: 'Podrobné pokyny krok za krokem',
            export: '4 typy exportu na vaši webovou stránku',
            chatGpt: 'ChatGPT pro ladění obsahu',
            keywordAnalysis: 'Automatická analýza klíčových slov',
            inspiration: 'Inspirace z TOP10 článků'
        },

        usageLimit: {
            warning: 'Jsi skutečně těžce nadprůměrný psavec. Super, fandíme ti, kvalitního obsahu není nikdy dost :-) ' +
                'Můžeš stále generovat články dále, ale pokud budeš tímto tempem pokračovat v dalším měsíci, domluvíme ' +
                'si s tebou přechod na vyšší tarif BUSINESS. Děkujeme za pochopení a používání SEOWRITEE.',
            stop: 'Stále ti fandíme ve tvém intenzivním psaní, ale už jsi překročil limit i těch ' +
                'nejintenzivnějších psavců :-). Pokud potřebuješ v tomto měsíci psát i nadále, ' +
                'zaplať si další články pomocí jednorázové platby a na další měsíc si s námi ' +
                'domluv cenu pro BUSINESS licenci na rudolf.sehnal@seowritee.com',
            useExtraInspiration: 'Využít jednorázový článek (zbývá: {0}).',
            buyExtraInspirations: 'Zakoupit jednorázové články',
        },

        terms: {
            IAccept: 'Akceptuji',
            termsOfService: 'Obchodní podmínky',
            privacyPolicy: 'Ochranu osobních údajů',
            info: 'Jsem si vědom, že budu platit automaticky měsíčně až do doby, dokud se ze služby neodhlásím.'
        },

        change: 'Rychle můžete kdykoliv přejít na vyšší nebo nižší tarif. Nebudeme vám za to účtovat žádné extra poplatky. Nevyžadujeme žádnou smlouvu. Pokud budete chtít přestat službu používat, jednoduše přestanete platit.',
        upgradeToUse: 'Zvolte libovolný tarif, abyste získali přístup k této funkci!',

        list: {
            title: 'Napište článek, který lidé najdou ve vyhledávači i v odpovědích AI.',
            items: {
                1: 'Stačí když zadáte klíčové slovo, popíšete téma článku a na jeden klik vám AI Lucy napíše celý text.',
                2: 'Aplikace vytvoří analýzu klíčových slov a podle nich napíše obsah článku.',
                3: 'Součástí napsaného textu jsou také odpovědi na nejčastěji kladené otázky, které lidi zajímají.',
                4: 'Získáte také inspirace pro vylepšení všech částí článku z nejlépe optimalizovaného textu na internetu.',
                5: 'Snadno si upravíte AI napsaný title, meta description, nadpisy H1 až H6, bodycopy atd.',
                6: 'Během psaní a úprav aplikace automaticky hlídá přes 20 SEO faktorů důležitých pro vysoké umístění ve vyhledávačích.',
                7: 'Pak už jen článek exportujete a vložíte na web.'
            },
            targetsLabel: 'Šablony pro vyhledávače i AI chaty',
            generate: {
                title: 'Napište nový článek',
                subtitle: 'Z klíčového slova — text pro Google, Gemini, ChatGPT, Perplexity i Copilot',
                items: {
                    1: 'Vyberete šablonu: Univerzální SEO, AI Overviews, Gemini, ChatGPT, Perplexity nebo Copilot',
                    2: 'AI Lucy sestaví zadání z živých odpovědí AI chatů, podotázek a faktů k citaci',
                    3: 'Celý článek s přímou odpovědí, přehlednými H2 a FAQ, které AI vkládá do odpovědí',
                    4: 'Během psaní hlídá SEO skóre i odhad, zda text vezme AI do své odpovědi',
                }
            },
            analyze: {
                title: 'Vylepšete stávající článek',
                subtitle: 'Z URL — silnější ve vyhledávači i v AI chatech',
                items: {
                    1: 'Stažení stránky a skóre z více než 20 SEO faktorů, včetně odhadu AI viditelnosti',
                    2: 'AI Lucy ukáže, co doplnit, aby článek citovaly AI Overviews i chaty',
                    3: 'Stejná šablona a tón jako u nového článku — AI Overviews, Gemini, ChatGPT…',
                    4: 'Export do DOCX, HTML nebo schránky',
                }
            },
        },

        plansLoadingError: {
            title: 'Chyba při načítání cen plánů.',
        }
    },
    newContentAvailable: 'Je k dispozici nová verze aplikace!',
    refresh: 'Obnovit',
    logout: 'Odhlásit se',

    register: 'Zaregistrujte se a nechte si vygenerovat nebo analyzovat článek zdarma!',
    noCardRequired: 'Kreditní karta není potřeba.',
    loginTagline: 'Copywriter pro vyhledávače i AI chaty',

    auth: {
        signInWithGoogle: 'Přihlásit se přes Google',
        signInWithEmail: 'Přihlásit se e-mailem',
        email: 'E-mail',
        password: 'Heslo',
        confirmPassword: 'Potvrzení hesla',
        signIn: 'Přihlásit se',
        createAccount: 'Vytvořit účet',
        noAccount: 'Nemáte účet?',
        haveAccount: 'Už máte účet?',
        tosPrefix: 'Pokračováním souhlasíte s našimi',
        termsLink: 'obchodními podmínkami',
        privacyLink: 'ochranou osobních údajů',
        showPassword: 'Zobrazit heslo',
        hidePassword: 'Skrýt heslo',
        forgotPassword: 'Zapomenuté heslo?',
        resetTitle: 'Obnovení hesla',
        resetSubtitle: 'Zadejte e-mail svého účtu. Pošleme vám odkaz pro nastavení nového hesla.',
        sendResetLink: 'Poslat odkaz',
        resetSent: 'Pokud účet s tímto e-mailem existuje, poslali jsme na něj odkaz pro nastavení nového hesla. Zkontrolujte i složku se spamem.',
        backToSignIn: 'Zpět na přihlášení',
        errors: {
            userNotFound: 'Účet s tímto e-mailem neexistuje.',
            wrongPassword: 'Nesprávné heslo.',
            invalidEmail: 'Zadejte platnou e-mailovou adresu.',
            emailAlreadyInUse: 'Účet s tímto e-mailem už existuje. Přihlaste se.',
            weakPassword: 'Heslo musí mít alespoň 6 znaků.',
            tooManyRequests: 'Příliš mnoho pokusů. Zkuste to později.',
            invalidCredential: 'Nesprávný e-mail nebo heslo.',
            userDisabled: 'Tento účet byl deaktivován.',
            network: 'Chyba sítě. Zkontrolujte připojení a zkuste to znovu.',
            passwordMismatch: 'Hesla se neshodují.',
            passwordRequired: 'Zadejte heslo.',
            googleFailed: 'Přihlášení přes Google se nepovedlo. Zkuste to znovu, nebo použijte e-mail.',
            popupBlocked: 'Prohlížeč zablokoval okno Google. Povolte vyskakovací okna na této stránce a zkuste to znovu.',
        },
    },

    unsavedChanges: {
        title: 'Neuložené změny',
        text: 'Opravdu chcete odejít?',
        stay: 'Zůstat',
        saveAndLeave: 'Uložit a odejít',
        leave: 'Odejít'
    },

    steps: {
        step: 'Krok',
        initForm: 'Brief, šablona a klíčové slovo',
        selectKeyword: 'Výběr klíčového slova',
        writeArticle: 'Psaní článku',
    },

    createBrief: {
        title: 'Nový článek',
        badge: 'AI generátor',
        subtitle: 'Vyplňte kroky v tomto pořadí. Po potvrzení můžete článek nechat napsat hned, nebo nejdřív upřesnit odstavce podle analýzy klíčových slov — ta mezitím běží na pozadí.',
        analyzeTitle: 'Analýza článku z URL',
        analyzeBadge: 'SEO úprava',
        analyzeSubtitle: 'Vyplňte kroky v tomto pořadí. Stáhneme obsah z URL a pak ho můžete vylepšit se stejnou šablonou a tónem.',
        optional: 'Volitelné',
        templateLabel: 'Šablona článku',
        marketLabel: 'Stát, jazyk a hlavní klíčové slovo',
        steps: {
            url: {
                title: 'Vložte adresu článku',
                help: 'Zadejte veřejnou URL stránky, kterou chcete upravit. Stáhneme z ní text a použijeme ho jako základ.',
            },
            brief: {
                title: 'Popište, o čem má článek být',
                help: 'Čím přesnější zadání, tím lépe AI pokryje správné body. Uveďte cíl článku, hlavní témata, srovnání, tipy z praxe nebo FAQ.',
                helpAnalyze: 'Stručně popište, o čem stránka je a co se má v úpravě zachovat nebo posílit. AI z toho pozná záměr vedle staženého textu.',
            },
            keyword: {
                title: 'Zvolte stát, jazyk a hlavní klíčové slovo',
                help: 'Článek se napíše ve zvoleném jazyce pro daný trh. Začněte psát frázi a z našeptávače vyberte variantu s vhodnou hledaností. Hlavní slovo půjde později ještě zpřesnit.',
            },
            template: {
                title: 'Vyberte šablonu struktury',
                help: 'Šablona určí, jak bude text postavený — přímá odpověď, podotázky, fakta k citaci. Google AI Overviews a AI Mode mají jednu kartu; Gemini je samostatný chat vedle ChatGPT, Perplexity a Copilot.',
            },
            style: {
                title: 'Nastavte tón, publikum a hloubku',
                help: 'Hodnoty jsou předvyplněné, můžete je nechat nebo změnit. Vedlejší klíčová slova jsou nepovinná — pokud je přidáte, AI je přirozeně zapojí do odstavců.',
            },
        },
        focusKeyword: 'Hlavní klíčové slovo',
        focusKeywordHint: 'např. jak vybrat tepelné čerpadlo',
        urlLabel: 'Adresa URL článku',
        briefLabel: 'Popis tématu a brief článku',
        briefHint: 'O čem má článek být a jaké body má pokrýt',
        briefExample: 'Např. návod pro začátečníky, srovnání typů, kalkulace nákladů, výhody a nevýhody, tipy z praxe a FAQ.',
        secondaryLabel: 'Vedlejší klíčová slova pro AI',
        secondaryPlaceholder: 'Přidat další vlastní klíčovou frázi…',
        secondaryCount: '{0} přidaných',
        secondaryHint: 'Sem pište další fráze, které má AI cíleně zapojit do odstavců.',
        addKeyword: 'Přidat',
        toneLabel: 'Tón komunikace',
        audienceLabel: 'Cílové publikum',
        depthLabel: 'Hloubka článku',
        submit: 'Pokračovat k analýze slov',
        submitAnalyze: 'Pokračovat k analýze',
        nextStepHint: 'Další krok: napsat článek hned, nebo upřesnit obsah podle čtyř skupin klíčových slov.',
        nextStepHintAnalyze: 'Další krok: spustíme stažení stránky a připravíme úpravu podle zadaného briefu a šablony.',
        refineSettings: 'Šablona a tón před vygenerováním',
        templates: {
            universal: {
                title: 'Univerzální SEO',
                blurb: 'Klasický článek s přímou odpovědí, přehlednými H2 a FAQ. Vhodný základ pro vyhledávače i citace v AI.',
            },
            aiOverviews: {
                title: 'AI Overviews',
                blurb: 'Přímá odpověď v prvních větách, pak H2 na podotázky: výběr, srovnání, pro koho. Krátké citovatelné pasáže, seznamy a FAQ — pro Google AI Overviews i AI Mode.',
            },
            aiMode: {
                title: 'AI Overviews',
                blurb: 'Přímá odpověď v prvních větách, pak H2 na podotázky: výběr, srovnání, pro koho. Krátké citovatelné pasáže, seznamy a FAQ — pro Google AI Overviews i AI Mode.',
            },
            gemini: {
                title: 'Gemini',
                blurb: 'Strukturovaná chatová odpověď: tabulky, seznamy a samostatné pasáže, které Gemini cituje. V každém bloku jasná kritéria, čísla a ověřitelný údaj.',
            },
            chatgpt: {
                title: 'ChatGPT',
                blurb: 'Konverzační, citovatelný text. Nejdřív odpověď, pak kroky a FAQ tak, aby šly vložit do chatové odpovědi.',
            },
            perplexity: {
                title: 'Perplexity',
                blurb: 'Fakta, čísla a krátké odstavce s jednou jasnou tezí. Připraveno k citaci ve vyhledávacím AI.',
            },
            copilot: {
                title: 'Copilot',
                blurb: 'Přímá odpověď hned na začátku, otázkové H2 a samostatné pasáže bez odkazů „výše“. Fakta, datum a ověřitelné zdroje, které Copilot zvedne do doporučení.',
            },
        },
        tones: {
            professional: 'Odborný a čtivý',
            friendly: 'Přátelský a srozumitelný',
            expert: 'Expertní a přesný',
            practical: 'Praktický, krok za krokem',
        },
        audiences: {
            general: 'Široká veřejnost a zákazníci',
            beginners: 'Začátečníci',
            professionals: 'Odborníci v oboru',
            customers: 'Lidé před nákupem',
        },
        depths: {
            short: 'Stručný článek (~800 slov)',
            standard: 'Standardní článek (~1200 slov)',
            deep: 'Hloubkový článek (~2000 slov)',
        },
    },

    articleChat: {
        stepOf: 'krok {0} z {1}',
        greeting: 'Ahoj, jsem AI Lucy. Pomůžu vám připravit článek.',
        greetingAnalyze: 'Ahoj, jsem AI Lucy. Pomůžu vám vylepšit stávající článek.',
        urlQuestion: 'Vložte adresu článku.',
        urlLead: 'Zadejte veřejnou adresu stránky. Stáhneme z ní text a použijeme ho jako základ.',
        urlLabel: 'Adresa URL článku (povinné)',
        urlExample: 'Například: https://www.vasweb.cz/clanek-pro-vylepseni',
        urlEmpty: 'Vložte adresu článku. Pak můžete pokračovat.',
        urlKeyHint: 'Enter pokračuje dál.',
        historyUrl: 'Adresa článku',
        loadedQuestion: 'Stránku mám načtenou.',
        loadedLead: 'AI Lucy nechala titulek a nadpisy, které ze stránky zůstaly. Zkontrolujte je a pokračujte.',
        loadedFrame: 'Co jsme načetli',
        loadedTitleLabel: 'Titulek stránky',
        loadedTitleMissing: 'Titulek se na stránce nenašel.',
        loadedOutlineLabel: 'Nadpisy, které zůstaly',
        loadedStays: 'Původní text zůstane, dokud vylepšení nepotvrdíte na stránce článku.',
        loadedReading: 'AI Lucy čte stránku.',
        loadedKeyHint: 'Enter pokračuje dál.',
        historyLoaded: 'Načtená stránka',
        goalQuestion: 'Co se má na stránce změnit?',
        goalLead: 'Předvybrané je doladění. AI Lucy se ptá, co má úprava udělat. Pokračovat otevře kontrolu zadání.',
        goalFrame: 'Cíl úpravy',
        goalKeyHint: 'Šipky přecházejí mezi kartami. Enter kartu vybere. Další Enter nebo Pokračovat pokračuje dál.',
        goalSectionsLabel: 'Části, které se mají přepsat',
        goalNeedSection: 'Vyberte aspoň jednu část. Pak můžete pokračovat.',
        goalNoSections: 'Na stránce není nadpis H2, který by šlo vybrat. Zvolte jiný cíl úpravy.',
        historyGoal: 'Cíl úpravy',
        goals: {
            polish: {
                title: 'Doladit pro vyhledávače a AI',
                blurb: 'Zachová text a nadpisy. Doladí titulek, úvod, klíčová slova a časté otázky.',
            },
            fill: {
                title: 'Doplnit chybějící témata',
                blurb: 'Přidá 1–3 nové části k tématům, která chybí. Stávající části zůstanou.',
            },
            rewrite: {
                title: 'Přepsat vybrané části',
                blurb: 'Přepíše jen části, které zaškrtnete. Ostatní části zůstanou tak, jak byly na stránce.',
            },
        },
        topicQuestion: 'Popište, o čem má článek být.',
        topicQuestionAnalyze: 'Stručně popište, o čem stránka je a co se má v úpravě zachovat nebo posílit.',
        topicLabel: 'Popis tématu (povinné)',
        wordCount: '{0} / {1} slov',
        chipsLabel: 'Doplnit do popisu',
        chips: {
            beginnerGuide: 'Návod pro začátečníky',
            typeComparison: 'Srovnání typů',
            costCalculation: 'Kalkulace nákladů',
            prosCons: 'Výhody a nevýhody',
            practicalTips: 'Tipy z praxe',
            faq: 'Časté otázky',
        },
        chipExamples: {
            beginnerGuide: 'Návod pro začátečníky, který vysvětlí téma od základu a provede čtenáře krok za krokem.',
            typeComparison: 'Srovnání typů, které postaví možnosti vedle sebe a pomůže s výběrem.',
            costCalculation: 'Kalkulace nákladů s orientačními částkami a s tím, co je v ceně.',
            prosCons: 'Výhody a nevýhody v přehledu, aby šlo porovnat přínos a omezení.',
            practicalTips: 'Tipy z praxe, které čtenář může použít hned.',
            faq: 'Časté otázky a krátké odpovědi k tématu.',
        },
        keyHint: 'Enter pokračuje dál. Shift a Enter vloží nový řádek.',
        localeQuestion: 'Zvolte stát a jazyk.',
        localeHint: 'Článek se napíše ve zvoleném jazyce. Stát a jazyk jsou v řádku dole a Změnit otevře jejich výběr.',
        localeLabel: 'Stát a jazyk',
        localeRow: 'Stát: {0} · Jazyk: {1}',
        localeKeyHint: 'Enter pokračuje dál.',
        summaryQuestion: 'Zkontrolujte zadání pro AI Lucy. Změnit otevře daný krok a po potvrzení se vrátíte sem.',
        summaryQuestionAnalyze: 'Zkontrolujte zadání pro AI Lucy. Změnit otevře daný krok a po potvrzení se vrátíte sem.',
        summaryStep: 'Kontrola zadání',
        summaryFrameLabel: 'Jak chcete článek napsat?',
        summaryFrameAnalyze: 'Jak chcete článek vylepšit?',
        generateNow: 'Generovat hned',
        generateNowLine: 'Připravím výběr odstavců z klíčových slov. Psát začnu po vašem potvrzení na stránce článku.',
        customizeFirst: 'Upravit před generováním',
        customizeFirstLine: 'Projdete a upravíte klíčová slova a pak spustíte psaní.',
        improveNow: 'Vylepšit hned',
        improveNowLine: 'Připravím výběr na stránce článku. Úpravu spustíte až po svém potvrzení tam.',
        customizeBeforeImprove: 'Upravit výběr před vylepšením',
        customizeBeforeImproveLine: 'Projdete klíčová slova a pak spustíte vylepšení na stránce článku.',
        keywordQuestion: 'Zvolte hlavní klíčové slovo.',
        keywordLead: 'Pod polem vyberte podobnou frázi s vhodnou hledaností. Stát a jazyk jsou v řádku nad frázemi a Změnit je otevře znovu.',
        keywordWhat: 'Klíčové slovo je fráze, kterou lidé píšou do vyhledávání.',
        keywordLabel: 'Hlavní klíčové slovo (povinné)',
        keywordEmpty: 'Napište hlavní klíčové slovo. Pak můžete pokračovat.',
        keywordKeyHint: 'Enter pokračuje dál.',
        suggestionsLoading: 'Načítám podobné fráze',
        suggestionsLabel: 'Podobné fráze',
        templateQuestion: 'Vyberte šablonu struktury.',
        templateLead: 'Předvybraná je Univerzální SEO. Můžete ji potvrdit, nebo zvolit jinou kartu.',
        templateLabel: 'Šablona struktury',
        templateKeyHint: 'Šipky přecházejí mezi kartami. Enter kartu vybere. Další Enter nebo Pokračovat pokračuje dál.',
        styleQuestion: 'Nastavte tón, publikum a hloubku.',
        styleLead: 'Hodnoty jsou předvyplněné. Vedlejší klíčová slova můžete doplnit podle potřeby.',
        styleLabel: 'Vedlejší klíčová slova (volitelné)',
        styleKeyHint: 'Enter v poli přidá vedlejší slovo. Pokračovat přidá i text, který v poli zůstal.',
        historyKeyword: 'Hlavní klíčové slovo',
        historyTemplate: 'Šablona',
        historyStyle: 'Tón, publikum a hloubka',
        historySecondary: 'Vedlejší slova',
        removeSecondary: 'Odebrat {0}',
        showEntered: 'Zobrazit zadané kroky',
        stepsReady: 'Kroky {0}–{1} hotové',
        enteredTitle: 'Zadané kroky',
        pickerTitle: 'Zvolte stát a jazyk',
        asking: 'AI Lucy připravuje otázku',
        emptyHint: 'Napište popis tématu. Pak můžete pokračovat.',
        historyTopic: 'Popis tématu',
        change: 'Změnit',
        resumeTitle: 'Pokračovat v rozepsaném zadání?',
        resumeYes: 'Pokračovat',
        resumeRestart: 'Začít znovu',
        formLead: 'Popis tématu, stát a jazyk zůstávají v tomto zadání. Další údaje doplníte v krocích pod tímto řádkem.',
    },

    keywords: {
        locationTitle: 'Vyberte stát a jazyk, ve kterém se článek napíše.',
        title: "Vložte hlavní klíčové slovo článku, například “koláč”, “jablečný koláč” nebo “jablečný koláč recept”.",
        subtitle: "Klíčové slovo budete moci upravit později v analýze klíčových slov.",
        label: "Klíčová slova",
        manage: "Spravovat klíčová slova",
        hint: "Klíčové slovo v SEO optimalizaci textů pro vyhledávače je termín nebo fráze, kterou lidé používají při vyhledávání informací na internetu. Tyto klíčové fráze jsou důležité, protože vyhledávače je používají k indexaci a řazení stránek výsledků vyhledávání.",
        location: "Stát",
        language: "Jazyk",
        keyword: "Klíčové slovo",

        confirm: "Potvrdit",

        edit: {
            locationTitle: 'Zvolený stát a jazyk, ve kterém se článek napíše.',
            title: "Zde můžete zadat hlavní klíčové slovo znovu",
            confirm: "Potvrdit"
        },

        toCount: 'Zaškrtnutá slova se počítají do hustoty podle kořene v nadpisu nebo větě, ne podle přesného znění.',
        occurrences: 'výskytů',
        countIntoDensity: 'započítat do hustoty',
        wordAlreadySelected: 'Dané slovo již je zadáno!',
        alreadyInList: 'Toto slovo už v seznamu je. Můžete dál psát.',
        densityHint: 'Hustotu i zvýraznění v článku počítáme z kořene slova (barf i barfu), ne z přesné shody řetězce.',

        keywordSelection: 'Hlavní klíčové slovo článku je',
        keywordSelectionCaption: 'Během několika desítek sekund vám AI Lucy napíše celý článek. Vylaďte ho, exportujte a publikujte na web.',
        allKeywords: 'Analýza klíčových slov',
        reviewKeywordsHint: 'Vyberte další klíčová slova, která má AI použít při vylepšení článku pro psaní samostatných odstavců. Hlavní klíčové slovo nechte, nebo můžete případně zvolit jiné.',
        editBrief: 'Upravit zadání článku',
        hideBrief: 'Skrýt zadání',
        applyAndEnhance: 'Vylepšit článek s vybranými slovy',
        selectNewKeyword: 'Zvolit nové klíčové slovo',
        closeAnalysis: 'Zavřít analýzu klíčových slov',
        avgMonthlySearches: 'Průměrná měsíční hledanost',

        lucy: {
            forkTitle: 'Jak chcete článek napsat?',
            forkTitleImprove: 'Jak chcete článek vylepšit?',
            forkLead: 'Obě cesty používají stejnou předvolbu z analýzy — liší se jen tím, jestli něco upravíte před psaním.',
            forkLeadImprove: 'Obě cesty používají stejnou předvolbu z analýzy — liší se jen tím, jestli upravíte výběr klíčových slov před vylepšením.',
            generateNow: 'Generovat hned',
            improveNow: 'Vylepšit hned',
            improveNowLine: 'AI Lucy hned vylepší článek z připraveného výběru — nemusíte rozbalovat analýzu.',
            customizeBeforeImprove: 'Upravit výběr před vylepšením',
            customizeBeforeImproveLine: 'Rozbalí analýzu klíčových slov: vypnete řádky a zvolíte Vlastní odstavec / Otázka / Doplnit do textu.',
            generateNowLine: 'AI Lucy napíše hned z připraveného výběru — nic nemusíte rozbalovat.',
            customizeFirst: 'Upravit před generováním',
            customizeFirstLine: 'Rozbalíte skupiny, vypnete řádky a zvolíte Vlastní odstavec / Otázka / Doplnit do textu.',
            fastSummaryTitle: 'AI Lucy napíše článek z {0} vybraných odstavců',
            fastSummaryDetail: 'Téma článku (H1) nezabírá slot. Citace a fakta z chatů jsou mimo limit 20 — skupiny můžete rozbalit a upravit výběr.',
            paragraphsCounter: 'Odstavce {0} / {1}',
            limitOk: 'Do limitu zbývá {0} odstavců (H2 nebo FAQ). Doplnit do textu a citace se nepočítají.',
            limitFull: 'Limit 20 je plný — další vlastní odstavec nebo otázku zapnete jen po úpravě jiného řádku.',
            limitOver: 'Překročen limit 20: vypněte jiný odstavec, nebo z něj udělejte „Doplnit do textu“. Vypínání vždy funguje.',
            limitEmpty: 'Žádný odstavec není zapnutý — Generovat je vidět, ale vypnuté.',
            limitBlocked: 'Limit 20 odstavců — vypněte jiný odstavec, nebo z něj udělejte „Doplnit do textu“.',
            alwaysInArticle: 'Vždy v článku',
            slotH2: '1 odstavec (H2)',
            slotFaq: '1 odstavec (FAQ)',
            intent: {
                section: 'Vlastní odstavec',
                faq: 'Otázka',
                weave: 'Doplnit do textu',
            },
            tip: {
                mainTopic: 'Hlavní téma článku — vždy v H1, nepočítá se do 20.',
                turnOff: 'Vypnout — vždy lze, i nad limitem 20.',
                turnOn: 'Zapnout pro AI Lucy.',
                blockedAtLimit: 'Nelze zapnout jako nový odstavec — nejdřív uvolněte slot pod 20.',
                intentSection: 'AI Lucy napíše samostatný odstavec s podnadpisem H2 k danému tématu.',
                intentFaq: 'AI Lucy zpracuje frázi jako otázku a odpověď ve FAQ.',
                intentWeave: 'AI Lucy zapracuje výraz do existujících částí bez nového podnadpisu — nepočítá se do 20.',
                limit20: 'Maximálně 20 vlastních sekcí (H2) a FAQ dohromady. Doplnit do textu, citace a fakta z chatů se nepočítají.',
                forkWaiting: 'Čekám na analýzu / nadpisy',
                forkImmediate: 'AI Lucy napíše teď z připraveného výběru: typicky až 6 vlastních sekcí, až 4 otázky, 2–3 citace a fakta z chatů z analýze. Nemusíte nic rozbalovat.',
                forkImmediateImprove: 'AI Lucy teď vylepší článek z připraveného výběru: typicky až 6 vlastních sekcí, až 4 otázky, 2–3 citace a fakta z chatů. Nemusíte rozbalovat analýzu.',
                forkCustomize: 'Rozbalí skupiny: vypnete řádky, přidáte long-tail a u každého zvolíte Vlastní odstavec, Otázku nebo Doplnit do textu (max. 20 odstavců).',
                forkCustomizeImprove: 'Rozbalí analýzu klíčových slov: vypnete řádky, přidáte long-tail a u každého zvolíte Vlastní odstavec, Otázku nebo Doplnit do textu (max. 20 odstavců).',
                proAiLucy: 'Zapne nebo vypne téma pro psaní. Vypnutí vždy funguje, i nad limitem 20 odstavců.',
                h1: 'Hlavní nadpis článku — téma z analýzy. Nezabírá slot mezi 20 odstavci.',
                h2: 'Podnadpis vlastní sekce článku. Každý zapnutý Vlastní odstavec zabírá jeden slot.',
                faq: 'Blok otázka a odpověď ve článku. Každá zapnutá Otázka zabírá jeden slot.',
            },
            abbr: {
                TOP: 'Stránky a klíčová slova z prvních organických výsledků Google pro dané téma — stejný zdroj jako inspirace z TOP obsahu.',
                PAS: 'Návrhy „Lidé také hledají“ u výsledků Google: související témata, která lidé často hledají po stejném dotazu.',
                PAA: 'Otázky, které Google ukazuje u výsledků hledání (People Also Ask).',
                LSI: 'Slova a sousloví, která s tématem souvisí a patří do přirozeného textu — entity a varianty, ne samostatné otázky.',
                Labs: 'Delší fráze a návrhy z nástroje Keyword Labs (long-tail dotazy z analýzy).',
                paa: 'Otázky, které Google ukazuje u výsledků hledání (People Also Ask).',
                pas: 'Návrhy „Lidé také hledají“ u výsledků Google.',
                lsi: 'Slova a sousloví, která s tématem souvisí a patří do přirozeného textu.',
                ac: 'Fráze z dopisování ve vyhledávacím poli Google (autocomplete), které nejsou otázky.',
                autocomplete: 'Fráze z dopisování ve vyhledávacím poli Google (autocomplete), které nejsou otázky.',
                organicFaq: 'Otázky z TOP stránek v organických výsledcích.',
                mentions: 'Fakta nebo citace z odpovědí AI chatů (AI Overview, ChatGPT, Gemini, Perplexity).',
                chat: 'Fakta nebo citace z odpovědí AI chatů.',
            },
            writeDisabledEmpty: 'Vyberte alespoň jeden vlastní odstavec (H2) nebo otázku (FAQ) — max. 20 odstavců.',
            writeDisabledOver: 'Máte {0} odstavců — vypněte jiný odstavec, nebo z něj udělejte „Doplnit do textu“.',
            generateNowNeedMore: 'Vybráno je {0} odstavců. Je jich málo — zapněte alespoň jeden vlastní odstavec (H2) nebo otázku (FAQ).',
        },
        info: {
            items: {
                1: 'Níže z navržených klíčových slovech ve sloupci “Vyberte hlavní klíčové slovo pro optimalizaci” můžete vybrat přesnější klíčové slovo, nebo můžete nechat to původní.',
                2: 'Hlavní klíčové slovo můžete vybrat pouze jedno. Na jeho základě získáte inspiraci pro vylepšení textů.',
                3: 'Jako hlavní klíčové slovo doporučujeme vyhrat takové, které má průměrný počet hledání měsíčně alespoň 400 a výše.',
                4: 'Ve sloupci “Vyberte pro psaní od AI Lucy” můžete změnit klíčová slova, na základě kterých budou odstavce článku napsány. Doporučujeme vybrat co nejvíce klíčových slov “související” a “otázky”.'
            },
            beforeButton: 'Zvolili jste hlavní klíčové slovo pro optimalizaci? Pokud ano, stiskněte tlačítko níže.',
            selectedForAi: 'Počet klíčových slov vybraných pro psaní textů od AI Lucy:',
            beforeButtonNoData: 'Lidé nevyhledávají klíčové slovo, které jste zadali nebo pouze několikrát měsíčně a také díky nízkému měsíčnímu počtu variant klíčového slova bude článek krátký. Máte nyní na výběr ze dvou možností.',
            tooManyKeywordsForAi: 'Zvolte nejvýše 20 klíčových slov pro AI Lucy'
        },

        list: {
            header: {
                title: 'Klíčová slova',
                keywordDifficulty: 'SEO obtížnost',
                unknownKeywordDifficulty: 'Neznámá SEO obtížnost',
                knownKeywordDifficulty: 'Čím je hodnota nižší, tím máte větší šanci získat lepší umístění ve výsledcích organického vyhledávání. Čím je hodnota vyšší, tím je klíčové slovo atraktivnější a konkurence vyšší.',
                averageSearches: 'Průměrný počet hledání měsíčně',
                aiDemand: 'AI poptávka',
                aiDemandHint: 'Poptávka v AI vyhledávání, ne klasické Google.',
                chooseKeyword: 'Vyberte hlavní klíčové slovo pro optimalizaci',
                chooseKeywordHint: 'Pokud chcete, můžete změnit hlavní klíčové slovo, na základě kterého získáte inpirace z 10 webů nejlépe umístěných ve vyhledávačích.',
                chooseForAi: 'Vyberte pro psaní od AI Lucy',
                chooseForAiHint: 'Pokud chcete, můžete změnit klíčová slova. Související slova se stanou nadpisy H2, otázky FAQ. AI Lucy napíše jeden článek, ne samostatný článek ke každému slovu.',
                forAiLucy: 'Pro AI Lucy'
            },
            variations: {
                title: 'varianty',
                description: 'Toto jsou blízké varianty hlavního klíčového slova. Sem tam jimi nahraďte hlavní klíčové slovo, ale pozor na gramatiku – nikdy v textu nepoužívejte gramaticky nesprávné varianty.',
                useHint: 'LSI slova z AI odpovědí mají štítek LSI. Doplnit do úvodu je vloží do článku a zaškrtne pro AI Lucy.'
            },
            questions: {
                title: 'otázky',
                description: 'Otázky související s hlavním klíčovým slovem. Zapracujte je do článku a odpovězte na ně co nejpraktičtěji.',
                useHint: 'Přidat H2 / FAQ zaškrtne otázku pro AI Lucy a vloží ji do editoru. Když odeberete FAQ a otázka není H2, zaškrtnutí se zruší.'
            },
            longTail: {
                title: 'long tail',
                description: 'Méně vyhledávané, ale přesnější dotazy související s hlavním klíčovým slovem. Můžete je zakomponovat do článku a podrobněji rozebrat.'
            },
            related: {
                title: 'související',
                description: 'Související klíčová slova jsou sekundární výrazy, které pomáhají zúžit zaměření hlavního klíčového slova. Tato klíčová slova umožňují cílit na specifičtější fráze, které se odvíjejí od daného tématu. Pomohou vám neodbíhat od tématu článku.'
            },
            workspace: {
                related: 'Související témata',
                relatedSub: 'Související témata — Related + PAS v jedné skupině',
                questions: 'Otázky',
                questionsSub: 'Otázky z vyhledávání, AI chatů a FAQ z TOP stránek',
                lsi: 'Varianty a LSI',
                lsiSub: 'Entity a blízké varianty z analýzy',
                longTail: 'Long-tail',
                longTailSub: 'Přesnější, méně hledané dotazy',
                autocomplete: 'Google automatické doplňování',
                autocompleteSub: 'Návrhy z Google automatického doplňování. Prázdné skupiny se nezobrazí.',
                gap: 'Témata konkurence',
                gapSub: 'Témata z mezer oproti konkurenčním stránkám',
                colPhrase: 'Fráze · zdroj',
                colQuestion: 'Otázka · zdroj · nápověda PAA',
                colTerm: 'Pojem · zdroj',
                colTopic: 'Téma · volume',
                colH2Faq: 'H2 · FAQ',
                colH2Intro: 'H2 · úvod',
                analysisHint: 'skupiny klíčových slov pod jedním rozbalením analýzy',
                liveCount: '{0} karty',
                citeCount: '{0} zdroje',
            },
            peopleAlsoSearch: 'Lidé také hledají',
            peopleAlsoSearchHint: 'Zaškrtnutím vyberete téma pro AI Lucy stejně jako související klíčové slovo. Přidat H2 ho vloží do editoru.',
            autocomplete: 'Google automatické doplňování',
            autocompleteHint: 'Návrhy Google Autocomplete. Zaškrtnutím je přidáte pro AI Lucy; otázky můžete dát i do FAQ.',
            gapTopics: 'Témata konkurence (volume)',
            gapTopicsHint: 'Klíčová slova, na která se objevují konkurenční stránky, s počtem hledání. Zaškrtnutím je přidáte jako téma H2 pro AI Lucy.',
            serp: {
                featured_snippet: 'U tohoto slova Google ukazuje featured snippet. Informace, výběr zůstává na zaškrtávátku pro AI Lucy.',
                people_also_ask: 'U tohoto slova Google ukazuje People also ask. Informace, výběr zůstává na zaškrtávátku pro AI Lucy.',
                ai_overview: 'U tohoto slova Google ukazuje AI Overview. Informace, výběr zůstává na zaškrtávátku pro AI Lucy.',
            },
            empty: 'Bohužel pro zvolené hlavní klíčové slovo nejsou dostupné alternativy pro tuto kategorii, protože je lidé na internetu nevyhledávají."',
            nothing: 'Bohužel pro zvolené hlavní klíčové slovo nejsou dostupné alternativy pro tuto kategorii, protože je lidé na internetu nevyhledávají."',
            chooseNewKeyword: 'Změnit klíčové slovo',
            chooseNewKeywordHint: 'Pokud je toto klíčové slovo výstižnější, můžete ho zvolit jako nové hlavní klíčové slovo pro vygenerování inspirací pro doladění textů.'
        },

        generateInspiration: 'Generovat SEO článek',
        generateInspirationAnyway: 'Přesto napsat článek',
        // Says exactly what CancelArticle gives back (src/service/articleCancelRefund.ts, #30943).
        deleteArticleAndRefundCredit: 'Zrušit tvorbu tohoto článku a vrátit kredit z měsíčního tarifu',
        deleteArticleKeepExtraCredit: 'Zrušit tvorbu tohoto článku (extra kredit se nevrací)',
        deleteArticleKeepFreeAnalysis: 'Zrušit tvorbu tohoto článku (analýza zdarma se nevrací)',
        deleteArticleNoRefund: 'Zrušit tvorbu tohoto článku',
        notCreatedInThisBillingPeriod: 'Nelze vrátit kredit, neboť článek nebyl vytvořen v tomto účtovacím období',

        aiPrompt: {
            title: 'Psaní textu AI',
            letHer: 'Dovolte AI Lucy napsat článek',
            description: 'Popište co nejvýstižněji téma článku, tedy vše, co by měl obsahovat. Čím přesněji, tím lépe.',
            promptExample: 'Příklad popisu: Rady a tipy, jak upéct lahodný jablečný koláč. Tradiční, moderní a zdravé recepty na jablečný koláč.',
        },

        simplify: {
            writeNow: 'Napsat článek hned',
            writeNowDescription: 'Použije váš brief, šablonu a tón. Odstavce se dopíší z předvybraných klíčových slov bez dalšího ladění.',
            specify: 'Upřesnit obsah článku',
            specifyDescription: 'Upravte hlavní slovo a čtyři skupiny klíčových slov (analýza už běží). Pak nechte AI napsat článek.',
        },

        analyze: {
            description: 'Zadejte URL adresu článku, jehož SEO skóre chcete vylepšit.',
            urlInputHint: 'Například: https://www.vasweb.cz/clanek-pro-vylepseni',
            keywordSelectionCaption: {
                begin: 'Upravte obsah z URL adresy podle',
                bold: 'faktorů hodnocení SEO',
                end: '. Pokud texty nebyly extrahovány, zkopírujte je ručně.'
            },
            analyzeNow: 'Analyzovat článek hned',
            analyzeNowDescription: 'Nechávám na aplikaci, aby se postarala o extrahování bez okamžitého upřesnění obsahu odstavců.',
            specifyDescription: 'Chci upřesnit obsah odstavců podle analýzy klíčových slov před extrahováním (minuta práce navíc).',
            aiPrompt: {
                description: 'Popište co nejvýstižněji téma článku, tedy vše, co obsahuje. Čím přesněji, tím lépe.',
            }
        }
    },

    article: {
        getInspired: 'Inspirace z TOP obsahu',
        editYours: 'Upravte text napsaný AI Lucy',
        words: 'slov',
        numOfWords: '{0} slov',
        details: "SEO parametry článku",
        keyWordsCount: "Počet klíčových slov v tomto textu inspirace",

        list: 'Vaše články',
        listMore: 'další',
        create: 'Vytvořit nový článek',
        view: 'Otevřít',
        createdAt: 'Vytvořen',
        empty: 'Zatím žádné články...',
        noTitle: "Článek bez titulku",

        createDescription: "Vytváření nového obsahu pro web nebo blog",

        analyze: {
            title: "Analýza článku z URL adresy",
            description: "Zlepšení obsahu zveřejněného na adrese URL",
            scrapeFail: {
                title: "Neúspěšná extrakce obsahu",
                description: "Je nám líto, ale SEOWRITEE nedokázal extrahovat obsah ze zadané adresy URL. Důvodem může být struktura webové stránky, omezení přístupu nebo nesprávná adresa URL. Zkontrolujte prosím, zda v adrese URL nejsou chyby, a zkuste to znovu.",
                creditRefunded: "Váš kredit byl vrácen.",
                deleteArticle: {
                    text: "Smazat článek",
                    descriptionMonthly: "Kredit z měsíčního tarifu bude vrácen. Můžete zkusit vytvořit nový článek nebo analyzovat jiný článek.",
                    descriptionExtra: "Extra kredit bude vrácen. Můžete zkusit vytvořit nový článek nebo analyzovat jiný článek.",
                    descriptionFree: "Analýza zdarma bude vrácena. Můžete zkusit vytvořit nový článek nebo analyzovat jiný článek.",
                    descriptionNoRefund: "Článek bude smazán. Můžete zkusit vytvořit nový článek nebo analyzovat jiný článek."
                },
                openEmpty: {
                    text: "Otevřít prázdný článek",
                    description: "Můžete vytvořit nový článek ručně s pomocí AI Lucy."
                }
            },
            scrapePartial: {
                title: "Částečná extrakce obsahu",
                description: "Je nám líto, ale SEOWRITEE nedokázal extrahovat veškerý obsah ze zadané adresy URL. Důvodem může být struktura webové stránky. Zkontrolujte prosím, zda v adrese URL nejsou chyby, a zkuste to znovu.",
                openPartial: {
                    text: "Otevřít částečný článek",
                    description: "Můžete doplnit chybějící části textu ručně nebo s pomocí AI Lucy."
                },
            }
        },

        contentExtraction: "Extrakce obsahu",

        save: 'Uložit článek',
        saving: {
            title: 'Ukládání článku...',
            content: 'Během ukládání článku není možné provádět změny.'
        },
        saved: {
            title: 'Článek úspěšně uložen!',
        },
        saveHeld: {
            title: 'AI Lucy ještě dopisuje článek',
            content: 'Článek se neuložil, aby se hotový text nenahradil prázdnými částmi.',
        },
        saveHeldReview: {
            title: 'Nejdřív projděte návrhy AI Lucy',
            content: 'Článek se neuložil. Dokud nerozhodnete o všech návrzích (Přijmout nebo Ponechat původní), nejde smazat ani přejmenovat část nebo otázku FAQ s textem.',
        },
        saveError: {
            title: 'Chyba při ukládání článku.',
            content: 'Během ukládání článku došlo k chybě. Zkontrolujte prosím připojení k internetu a zkuste to znovu.',
        },

        updating: 'Aktualizace článku',
        updated: 'Článek aktualizován',

        generating: {
            title: 'Generování článku...',
            content: 'AI Lucy napíše celý článek najednou — včetně všech vybraných FAQ — v cílové délce a potom ho najednou vyplní do H1–H6, FAQ a snippetu. Cílová délka je pro celý článek, nevynechá pozdější odstavce. Jakmile se texty uloží, odstavce jdou hned upravit — druhé vylepšování textů se nespouští.',
            localContent: 'AI Lucy se na tomto náhledu snaží napsat článek. Když se texty nenačtou, za chvíli se otevřou prázdné odstavce k úpravě.',
            continueWithoutAi: 'Otevřít odstavce bez AI',
            localDoneTitle: 'Odstavce jsou připravené k úpravě',
            localDoneContent: 'AI Lucy na tomto náhledu nenačetla texty. Můžete psát ručně. Na vývojovém webu AI Lucy píše naplno.',
        },
        generated: {
            title: 'Článek úspěšně vygenerován!',
        },
        generateError: {
            title: 'Chyba při generování článku.',
            content: 'Některé texty se nepodařilo vygenerovat. Můžete je doplnit ručně.',
        },

        enhancing: {
            title: 'Vylepšování článku...',
            content: 'Během vylepšování článku není možné provádět změny.',
            localContent: 'AI Lucy se na tomto náhledu snaží vylepšit článek. Když se texty nenačtou, za chvíli odemkneme odstavce k úpravě.',
            continueWithoutAi: 'Pokračovat bez AI',
            localDoneTitle: 'Úpravy jsou odemčené',
            localDoneContent: 'AI Lucy na tomto náhledu nenačetla nové texty. Stažený článek a prázdné odstavce můžete upravit ručně. Na vývojovém webu AI Lucy píše naplno.',
        },
        enhanced: {
            title: 'Článek úspěšně vylepšen!',
        },
        blockProposals: {
            title: 'AI Lucy připravila návrhy k částem',
            lead: 'Původní text zůstává, dokud návrh nepřijmete.',
            original: 'Původní text',
            proposal: 'Návrh',
            accept: 'Přijmout',
            keep: 'Ponechat původní',
            newSection: 'Nová část',
            accepted: 'Přijato',
            kept: 'Ponecháno',
            retry: 'Zkusit znovu',
            failedMissing: 'AI Lucy v návrhu vynechala čísla, roky nebo částky z původního textu. Tuto část můžete zkusit znovu.',
            failedInvented: 'AI Lucy do návrhu přidala číslo nebo rok, který na stránce není. Tuto část můžete zkusit znovu.',
            failedChangedNumberMeaning: 'Změnil se význam čísla.',
            failedInstructionLeak: 'AI Lucy do návrhu propašovala pokyny pro validaci místo textu článku. Tuto část můžete zkusit znovu.',
            failedUnusable: 'AI Lucy tuto část nepřipravila. Můžete to zkusit znovu.',
            failedEmptyAnswer: 'AI Lucy nevrátila text této části. Můžete to zkusit znovu.',
            tableKept: 'Tabulku ponecháváme beze změny.',
            figuresKept: 'Čísla ponecháváme tak, jak jsou ve zdroji.',
            warningMissing: 'AI Lucy v návrhu vynechala několik čísel z původního textu.',
            readyTitle: 'AI Lucy má návrhy k částem',
            readyContent: 'Původní text zůstává, dokud návrh nepřijmete.',
            settled: 'Hotovo, všechny návrhy jsou vyřešené.',
        },
        enhanceError: {
            title: 'Chyba při vylepšování článku.',
            content: 'Během vylepšování článku došlo k chybě. Zkontrolujte prosím připojení k internetu a zkuste to znovu.',
        },
        partsFailed: {
            title: 'AI Lucy vylepšení článku nedokončila',
            content: 'Některá část selhala, nebo vypršel čas dřív, než byly všechny části hotové. Generování můžete spustit znovu.',
            retry: 'Zkusit znovu',
        },
        wholeFailed: {
            title: 'AI Lucy článek nedopsala',
            content: 'Některé části článku se nepodařilo vygenerovat. Zkuste je vygenerovat znovu, nebo je doplňte ručně.',
            retry: 'Zkusit znovu',
        },
        manualEnhance: {
            title: 'Vylepšení obsahu článku',
            titleReady: 'Článek je připravený k vylepšení',
            description: 'Vybraná slova z briefu (H2 a FAQ) AI Lucy použije. Analýzu klíčových slov otevřete, jen když chcete přidat další.',
            descriptionReady: 'Vybraná klíčová slova jsou připravená. AI Lucy teď přidá další relevantní části článku.',
            danger: 'Vylepšení přidá další části článku. Tento krok je nevratný.',
            enhance: 'Vylepšit článek',
            enhanceNow: 'Vylepšit článek hned',
            loadingPage: 'AI Lucy načítá stránku…',
            tooltip: {
                tooManyKeywords: 'Pro vylepšení článku zvolte nejvýše 20 klíčových slov',
                noKeywords: 'Pro vylepšení článku zvolte alespoň jedno klíčové slovo',
            }
        },

        polishing: {
            title: 'Vylepšování článku...',
            content: 'Během vylepšování článku není možné provádět změny.'
        },
        polished: {
            title: 'Článek úspěšně vylepšen!',
        },
        polishError: {
            title: 'Chyba při vylepšování článku.',
            content: 'Během vylepšování článku došlo k chybě. Zkontrolujte prosím připojení k internetu a zkuste to znovu.',
        },
        manualPolish: {
            title: 'Vylepšení obsahu článku',
            description: 'Tento krok už není potřeba. AI Lucy napíše celý článek najednou a rovnou ho rozdělí do nadpisů H. Druhé vylepšování textů po generování se nespouští.',
            danger: 'Vylepšení by přepsalo původní verzi článku. Tento krok se po vygenerování celého článku nespouští.',
            polish: 'Vylepšit článek',
        },

        loadingError: {
            title: 'Chyba při načítání článku.',
            content: 'Během načítání článku došlo k chybě. Zkontrolujte prosím připojení k internetu a zkuste to znovu.',
        },

        exportError: {
            docx: {
                title: 'Chyba při vytváření DOCX exportu článku.',
            },
            clipboard: {
                title: 'Chyba při kopírování článku do schránky.',
            },
            basic: {
                title: 'Chyba při exportu článku.',
            }
        },

        overview: {
            selectedKeyword: {
                title: 'Zvolené klíčové slovo',
                description: 'Hlavní klíčové slovo, neboli téma, o kterém píšete článek. Pomůžeme vám získat inspiraci pro jeho detailní popis a vysvětlení čtenářům, tedy cílové skupině.'
            },
            idealURL: {
                title: 'Ideální URL článku',
                description: 'Takto by měla vypadat URL článku, vstupní stránky nebo jakákoliv část webu z hlediska SEO. Čím kratší a relevantnější ke klíčovému slovu bude, tím lépe. Varianta s www nebo bez závisí na tom, jak máte nastavenou doménu webu.'
            },
            ALTDescription: {
                title: 'Popis obrázku ALT',
                description: 'Obrázky popište hlavním klíčovým slovem a jeho variantami atributem ALT obrázku. Tuto možnost většinou najdete v administraci webového obsahu.'
            },
            recommendedLength: {
                title: 'Minimální doporučená délka článku',
                description: 'Pokud chcete být na předních pozicích v organickém vyhledávání, váš článek musí mít správný počet slov. Vypočítali jsme minimální počet slov nejlepších článků na internetu a budeme váš počet slov sledovat za vás.'
            },
            recommendedDensity: {
                title: 'Doporučená hustota klíčových slov',
                description: 'Hlavní klíčové slovo má v textu zaznít přirozeně — v gramaticky správném tvaru, ne jako vycpaný řetězec. Hustotu hlídáme podle kořene slova.'
            },
            length: "Délka",
            density: "Hustota vybraných slov",
            moreDetails: "Více detailů",
            lessDetails: "Méně detailů",
            recommendedKeywordCount: 'při délce článku {0} slov je to {1} klíčových slov'
        },

        label: {
            metaTitle: 'meta nadpis',
            metaDescription: 'meta popis',
            h1h: 'H1 ' + heading,
            h1p: 'H1 ' + paragraph,
            h2h: 'H2 ' + heading,
            h2p: 'H2 ' + paragraph,
            h3h: 'H3 ' + heading,
            h3p: 'H3 ' + paragraph,
            h4h: 'H4 ' + heading,
            h4p: 'H4 ' + paragraph,
            h5h: 'H5 ' + heading,
            h5p: 'H5 ' + paragraph,
            h6h: 'H6 ' + heading,
            h6p: 'H6 ' + paragraph,
            images: 'obrázky',
        },

        eat: {
            chip: 'Autor a E-E-A-T',
            title: 'Autor, datum a důvěryhodnost',
            description: 'Google i AI systémy berou jméno autora, datum aktualizace a odborné bio jako E-E-A-T signál. Údaje se načtou z analyzované URL, můžete je upravit.',
            loading: 'Načítám autora a datum z původní stránky…',
            empty: 'Doplňte autora, datum a krátké bio. U článku z URL je načteme z originálu, pokud je stránka zveřejňuje.',
            author: 'Autor',
            authorPlaceholder: 'Např. Carlos Silva',
            role: 'Pozice autora',
            rolePlaceholder: 'Např. Content Production Expert',
            contributors: 'Přispěvatelé',
            contributorsPlaceholder: 'Další editoři nebo recenzenti, oddělení čárkou',
            published: 'Datum zveřejnění',
            updated: 'Datum aktualizace',
            datePlaceholder: 'Např. 3. června 2026',
            readMinutes: 'Délka čtení (min)',
            minRead: 'min čtení',
            bio: 'Bio autora',
            bioPlaceholder: 'Kdo článek napsal, jakou má praxi a proč je k tématu kompetentní.',
        },

        inspirationFor: {
            title: 'Inspirace pro {0}',
            metaTitle: 'Text, který se objeví ve výsledcích vyhledávání. Inspirujte se těmi nejlepšími titulky a napište ještě lépe, atraktivněji a výstižněji.',
            metaDescription: 'Text, který se objeví ve výsledcích vyhledávání. Inspirujte se těmi nejlepšími popisy a napište ještě lépe, atraktivněji a výstižněji.',
            h: 'Inspirujte se titulky nejlepších článků na internetu a napište jej ještě atraktivněji a výstižněji. ',
            p: 'Inspirujte se odstavci nejlepších článků na internetu a napište jej ještě atraktivněji a výstižněji.'
        },
        inspirationDetail: 'Otevřít detail',
        noInspiration: 'Žádná ze stránek pro inspiraci nepoužila tuto sekci, vy ji ale můžete vyplnit.',
        hideInspiration: 'Skrýt tuto inspiraci',
        hideAndMarkUnrelevant: 'Skrýt a označit jako nerelevantní',
        copyInspiration: 'Zkopírovat k přepsání',
        copiedToClipboard: 'Zkopírováno do schránky!',

        placeholder: {
            metaTitle: 'Sem napište meta nadpis',
            metaDescription: 'Sem napište meta popis',
            heading: 'Sem napište nadpis',
            paragraph: 'Sem napište odstavec',
            question: 'Sem napište otázku',
            answer: 'Sem napište odpověď',
        },

        writeBetter: {
            meta: 'Upravte {0}, aby byl atraktivnější než inspirace',
            heading: 'Upravte {0}, aby byl výstižnější než inspirace',
            headingBrief: '{0} nadpis a odstavec',
            paragraph: 'Upravte odstavec, aby byl zajímavější než inspirace',
            placeholder: {
                meta: 'Sem napište {0} ideálně max {1} znaků dlouhý',
                heading: 'Napište vlastní odstavec, kterým vysvětlíte, co popisuje {0}',
                paragraph: 'Sem napište odstavec, který bude souviset s nadpisem výše a detailně téma vysvětlete'
            }
        },

        contentList: {
            title: 'Obsah článku',
            hint: 'Bude automaticky generován při psaní článku.',
            dragHint: 'Přetažením změnit pořadí nadpisů',
            emptyHeading: '(prázdný nadpis)',
            description: 'Seznam obsahu článku je důležitý pro rychlou orientaci čtenáře v textu. Vytvoří se automaticky během psaní nadpisů.',
            empty: 'nevyplněno',
            showAll: 'Zobrazit vše ({count})',
            showLess: 'Zobrazit méně',
        },

        questions: {
            title: 'Upravte odpověď nebo napište vlastní',
            question: 'Otázka',
            answer: 'Odpověď',
            remove: 'Smazat otázku'
        },

        answers: {
            title: "Odpovědi na otázky",
            description: "Kvalitu optimalizace článku a také obsahovou hodnotu pro čtenáře vám zvýší zodpovězení na často kladené otázky úzce související s klíčovým slovem."
        },

        tips: {
            label: 'Tipy',
            metaTitle: 'Kromě hlavního klíčového slova použijte v nadpisu číslovku, otázku jak, proč nebo kde, výčet, atraktivní cenu atd. a maximálně využijte doporučený počet znaků.',
            metaDescription: 'Pomocí hlavního klíčového slova a dalších informací popište co nejatraktivněji obsah článku pomocí výčtu obsahu, unikátních výhod, benefitů. Maximálně využijte doporučený počet znaků.',
            h1h: 'V nadpise použijte klíčové slovo a popište hlavní sdělení článku. Nadpis H1 použijte v článku pouze jednou.',
            h1p: 'Hlavní klíčové slovo smysluplně použijte v začátku odstavce a shrňte v něm obsah celého článku tak, aby jste čtenáře navnadili přečíst si ho celý až do konce.',
            h2h: 'V tomto a dalších nadpisech použijte další variantu klíčového slova nebo klíčové slovo ve formě otázky. Nadpisy H2 až H6 můžete v článku použít opakovaně.'
        },

        extendWithAi: {
            fillPrompt: 'Vyplňte instrukci pro AI Lucy',
            generating: 'AI Lucy připravuje další část textu…',
            heading: {
                run: 'Generovat odstavec pro tento nadpis',
            },
            paragraph: {
                run: 'Generovat další část',
                toggle: 'Rozšířit odstavec za pomoci AI Lucy',
                prompt: 'Popište AI Lucy, o čem má v tomto odstavci psát dále.',
                use: 'Přidat k odstavci',
            },
            question: {
                run: 'Generovat odpověď na tuto otázku',
            },
            answer: {
                run: 'Generovat další část',
                toggle: 'Rozšířit odpověď na otázku za pomoci AI Lucy',
                prompt: 'Popište AI Lucy, o čem má v odpovědi na tuto otázku psát dále',
                use: 'Přidat k odpovědi',
            },
            discard: {
                tooltip: 'Zahodit',
                title: 'Určitě chcete zahodit následující rozšíření?',
                confirm: 'Zahodit'
            },
        },

        addSubpart: 'Vložit sekci "{0}" s odstavcem',
        addAnotherSubpart: 'Vložit další sekci "{0}" s odstavcem',
        dragBlock: 'Přetažením změnit pořadí',
        removeSubpart: {
            tooltip: 'Smazat tento nadpis vč. odstavce',
            title: 'Určitě chcete smazat následující {0} včetně jeho odstavce?',
            confirm: 'Smazat'
        },
        addQuestion: 'Vložit další otázku',
        faqIncompletePruned: {
            title: 'Prázdné FAQ nejdou do článku',
            content: 'Otázka bez odpovědi (nebo naopak) se z náhledu a exportu vynechá. Doplňte ji, nebo ji před generováním smažte.',
        },
        removeQuestion: {
            tooltip: 'Smazat tuto otázku',
            title: 'Určitě chcete smazat následující otázku včetně její odpovědi?',
            confirm: 'Smazat',
        },

        images: {
            title: 'Obrázky v článku',
            description: 'Seznam obrázků použitých v článku. Vyplňte ALT atributy obrázků, aby jej SEOWRITEE mohl zkontrolovat.',
            add: 'Přidat obrázek',
            remove: 'Smazat obrázek',
            showAll: 'Zobrazit vše ({count})',
            showLess: 'Zobrazit méně',
            alt: {
                header: 'ALT atribut',
                placeholder: 'Zde napište popis obrázku'
            },
            url: {
                header: 'URL adresa externě umístěného obrázku',
                placeholder: 'https://www.vasweb.cz/image.jpg',
            }
        },

        SERPPreview: {
            title: 'Podívejte se, jak bude vypadat váš SERP',
            description: 'Přesně tak lidé uvidí stránku vašeho webu ve výsledcích organického vyhledávání. Ujistěte se, že je atraktivní a láká lidi ke kliknutí. Ovlivní to návštěvnost vašeho webu. SERP znamená stránku s výsledky vyhledávání vyhledávače.'
        },
        urlSuggestion: {
            ideal: 'Doporučená ideální URL',
            yours: 'Vaše URL',
            redirectNote: 'Pokud URL změníte, nezapomeňte ho trvale přesměrovat pomocí kódu 301.',
        },
        preview: 'Náhled stránky',
        previewTooltip: 'Uvidíte článek jako hotovou stránku: čtenářský náhled na desktopu i mobilu, HTML s mikrodaty, Schema.org JSON-LD, kód pro CMS, Open Graph a kontrolu, co ve výstupu sedí.',
        previewDialog: {
            title: 'Náhled celého článku & HTML kód',
            badge: 'Reader & Microdata',
            subtitle: 'Vizuální náhled zformátovaného textu nebo zobrazení vedle sebe s HTML kódem a Schema.org mikrodaty.',
            expand: 'Roztáhnout na celou obrazovku',
            reader: 'Čtenářský náhled',
            split: 'Vedle sebe (Náhled + HTML)',
            htmlMicrodata: 'HTML kód & Microdata',
            desktop: 'Desktop',
            mobile: 'Mobil',
            reading: 'Čtení',
            copyHtml: 'Kopírovat HTML',
            markdown: 'Markdown',
            print: 'Tisk',
            printBlocked: 'Tisk z tohoto okna nejde spustit. Na vašem počítači v Chrome, Edge nebo Safari se otevře klasické systémové okno Tisk s článkem.',
            download: 'Stáhnout',
            copyCode: 'Kopírovat kód',
            schemaValidator: 'Schema.org Validátor',
            searchCode: 'Hledat v kódu (např. itemprop, ld+json)…',
            lines: '{0} řádků',
            bytes: '{0} bajtů',
            untitled: 'Bez názvu',
            updatedNow: 'Aktualizováno právě teď',
            readTime: '{0} min čtení',
            words: '{0} slov',
            microdataLive: 'Automatická kontrola mikrodat & Schema.org JSON-LD aktivní',
            close: 'Zavřít náhled',
            tabs: {
                full: 'Kompletní HTML (s mikrodaty)',
                schema: 'Schema JSON-LD',
                cms: 'HTML pro CMS (Body)',
                audit: 'Mikrodata & Schema audit',
            },
            kind: {
                full: 'HTML5 + Microdata',
                schema: 'JSON-LD',
                cms: 'HTML body',
            },
            audit: {
                schema: 'JSON-LD strukturovaná data jsou v kódu',
                blogPosting: 'Typ BlogPosting je vyplněný',
                headline: 'Headline / meta title je vyplněný',
                description: 'Description je vyplněný',
                canonical: 'Canonical URL je připravená',
                openGraph: 'Open Graph značky jsou v <head>',
                h1: 'Článek má H1',
                faq: 'FAQ je kompletní, nebo v článku žádné FAQ není',
                images: 'Obrázky mají ALT, nebo článek zatím žádné nemá',
                lang: 'Jazyk HTML dokumentu je nastavený',
            }
        },

        currentLength: {
            title: 'Aktuální délka vašeho článku',
            description: 'Aktuální počet slov za vás spočítáme v průběhu psaní článku a zároveň porovnáme s jeho ideálním počtem.'
        },
        currentDensity: {
            title: 'Aktuální hustota vybraných slov',
            description: 'Hustotu počítáme z kořene klíčového slova v nadpisech a větách, ne z přesné shody řetězce, a hlídáme ideální počet výskytů.'
        },
        export: {
            title: 'Export článku',
            description: 'Hotový článek můžete exportovat čtyřmi různými způsoby, včetně HTML kódu, a vložit jej přímo do administrace vašeho webu nebo poslat někomu jinému k nasazení či použití.'
        },

        density: {
            low: 'Přidejte nějaká klíčová slova',
            ok: 'Množství klíčových slov je ideální',
            high: 'Klíčová slova opakujete příliš často, některá odstraňte'
        },

        download: {
            title: 'Stáhněte si obsah optimalizovaného článku a vložte jej do redakčního systému vašeho webu',
            formats: {
                [DownloadType.DOCX]: 'docx',
                [DownloadType.HTML]: 'html',
                [DownloadType.CLIPBOARD]: 'Zkopírovat do schránky',
                [DownloadType.RTF]: 'rtf'
            }
        },

        generateNewInspiration: 'Generovat další článek',

        recommendation: {
            title: 'Další tipy, jak článek optimalizovat a získat lepší pozice webu v internetových vyhledávačích',
            description: 'Zde je několik dalších tipů a triků, které pomohou vašemu článku umístit se vysoko ve výsledcích organického vyhledávání a získat bezplatnou návštěvnost webu.',
            items: {
                1: 'Texty napsané AI Lucy doplňte zajímavými informacemi, myšlenkami a využijte inspirace z TOP obsahu.',
                2: 'Do článku vložte obrázky, videa, grafy atd. a do popisu ALT dejte příslušná klíčová slova.',
                3: 'S hustotou klíčových slov v článku to nepřehánějte, držte se v rozmezí doporučené hustoty klíčového slova.',
                4: 'Inspirace nikdy nekopírujte do vašeho článku, protože vyhledávače ignorují duplikovaný obsah.',
                5: 'Váš článek by měl mít minimálně stejný počet slov, ideálně větší počet slov, než má článek umístěný na první pozici.',
                6: 'Vložte do článku odkazy na zajímavé zdroje související s tématem, které nejsou konkurenční vaší firmě.',
                7: 'Prolinkujte obsah článku na další stránky vašeho webu, pokud zmiňujete něco, co už jste napsali.',
                8: 'Obsah článku průběžně aktualizujte, vyhledávače lépe hodnotí aktuální informace.',
                9: 'Získejte pro článek kvalitní zpětné odkazy (přirozené, neplacené, z důvěrohodných a nekonkurenčních webů).',
                10: 'Sdílejte článek na sociálních sítích a oslovte ostatní autory, kteří píší o stejném tématu.',
                11: 'Vytvořte z obsahu článku video, podcast či prezentaci a sdílejte je vhodně na internetu.',
                12: 'Pokud hledáte profesionální poradenství s obsahovým a technickým SEO, obraťte se na nás přímo na https://seomaker.cz/'
            }
        },

        openAi: {
            loading: 'AI Lucy připravuje text…',
        }
    },

    seoScore: {
        seo: 'SEO',
        score: 'SEO skóre',
        showDetails: 'Zobrazit detaily',
        legendRed: 'Kritické',
        legendYellow: 'Upozornění',
        legendGreen: 'Splněno',
        emptyGroup: 'Žádné SEO faktory v této barvě',
        schemaMarkup: {
            label: 'Schema Markup & strukturovaná data',
            description: 'Do kódu článku vložte JSON-LD (BlogPosting, FAQPage) pro Google a AI Overviews.',
            green: 'JSON-LD je v článku',
            red: 'JSON-LD chybí',
        },
        aiVisibility: {
            label: 'Odhad AI viditelnosti',
            description: 'Odhad, jak dobře článek poslouží jako zdroj pro Google AI Overviews, Gemini, ChatGPT, Perplexity a Copilot. Aktuálně {0} %.',
            green: 'Dobrá šance na citaci v AI odpovědích ({0} %)',
            yellow: 'Částečná AI viditelnost ({0} %) — chybí FAQ, fakta nebo schema',
            red: 'Nízká AI viditelnost ({0} %) — doplňte konverzační FAQ a strukturovaná data',
        },
        eeatScore: {
            label: 'E-E-A-T hodnocení',
            description: 'Experience, Expertise, Authoritativeness, Trustworthiness — čtyři pilíře kvality obsahu podle Googlu. Skóre {0} / 100.',
            green: 'Silné E-E-A-T signály ({0} / 100)',
            yellow: 'E-E-A-T jde posílit ({0} / 100) — přidejte zkušenost, citace a důvěryhodnost',
            red: 'Slabé E-E-A-T ({0} / 100) — chybí praxe, hloubka nebo důvěryhodné zdroje',
        },
        eatAuthor: {
            label: 'Podepsaný autor článku',
            description: 'Článek má jmenovaného autora, kterého Google čte jako E-E-A-T signál Experience a Authoritativeness.',
            green: 'Autor je vyplněný',
            red: 'Autor chybí',
        },
        eatDate: {
            label: 'Datum zveřejnění nebo aktualizace',
            description: 'Viditelné datum říká, že obsah je udržovaný. U analyzované URL bereme datum z originálu.',
            green: 'Datum je vyplněné',
            red: 'Datum chybí',
        },
        eatBio: {
            label: 'Odborné bio autora',
            description: 'Krátké bio (praxe, role, kompetence) posiluje Expertise. Ideálně aspoň dvě věty.',
            green: 'Bio je vyplněné',
            yellow: 'Bio chybí nebo je příliš krátké',
        },
        faqPresent: {
            label: 'FAQ sekce článku',
            description: 'Počítají se otázky s odpověďmi v FAQ editoru i nadpisy ve formě otázky v textu článku. Nalezených Q&A: {0}',
            green: 'Alespoň jedna otázka a odpověď',
            red: 'FAQ chybí',
        },
        keywordVariants: {
            label: 'Varianty klíčového slova',
            description: 'Text článku by měl obsahovat více variant hlavního klíčového slova. Naleznete je v analýze klíčových slov: Klíčová slova - související. Zadané varianty klíčového slova: {0}',
            green: 'Dvě nebo více',
            yellow: 'Jedna',
            red: 'Žádná',
        },
        keywordInSlug: {
            label: 'URL článku obsahuje klíčové slovo',
            description: 'URL stačí, když obsahuje slova klíčového výrazu — v jakémkoli pořadí, klidně proložená jinými slovy, s lomítkem na konci i bez něj. Doporučená ideální URL je "{1}".',
            green: 'Cesta URL obsahuje slova klíčového výrazu.',
            red: 'Cesta URL zatím neobsahuje slova klíčového výrazu "{0}".',
        },
        imgAltIncludesKeyword: {
            label: 'ALT obrázků obsahuje klíčové slovo',
            description: 'Zajistěte, aby ALT, což je alternativní text obrázku obsahoval hlavní klíčové slovo. ALT obrázků obsahuje "{1}"',
            green: 'Obsahuje',
            red: 'Neobsahuje',
        },
        titleIncludesKeyword: {
            label: 'Meta nadpis obsahuje klíčové slovo',
            description: 'Meta title (nadpis) je HTML tag s největším významem pro SEO a musí obsahovat, ideálně hned na začátku, hlavní klíčové slovo. Meta nadpis obsahuje "{1}"',
            green: 'Obsahuje',
            red: 'Neobsahuje',
        },
        titleLength: {
            label: 'Délka meta nadpisu',
            description: 'Délka meta nadpisu je {0} znaků',
            green: 'Méně než {1} znaků',
            red: 'Více než {1} znaků',
        },
        descriptionIncludesKeyword: {
            label: 'Meta popis obsahuje klíčové slovo',
            description: 'Meta description (popis) tag informuje návštěvníky webu a také vyhledávače, o čem váš článek je. Zajistěte, aby obsahoval hlavní klíčové slovo. Meta popis obsahuje "{1}"',
            green: 'Obsahuje',
            red: 'Neobsahuje',
        },
        descriptionLength: {
            label: 'Délka meta popisu',
            description: 'Délka meta popisu je {0} znaků',
            green: 'Méně než {1} znaků',
            red: 'Více než {1} znaků',
        },
        keywordDensity: {
            label: 'Hustota hlavního klíčového slova',
            description: 'Hlavní klíčové slovo by se mělo přirozeně vyskytovat v textu v gramaticky správném tvaru. Nepřehánějte to s množstvím. Hustotu počítáme z kořene slova, ne z přesného znění. Hlavní klíčové slovo má hustotu {0}%',
            green: 'V doporučeném rozsahu {1} - {2}%',
            yellow: 'Nízká hustota (< {1}%)',
            red: 'Vysoká hustota (> {2}%)',
        },
        serpIsComplete: {
            label: 'SERP je vyplněný',
            description: 'Zajistěte, aby Meta nadpis a Meta popis byly v kódu článku vyplněny. Meta nadpis a meta popis jsou vyplněné',
            green: 'Vyplněné',
            red: 'Nevyplněné',
        },
        avgWordCountOfTopTen: {
            label: 'Delší než průměrný článek z TOP 10',
            description: 'Aktuální délka článku je {0} slov',
            green: 'Více než {1} slov.',
            red: 'Méně než {1} slov.',
        },
        longestWordCountOfTopTen: {
            label: 'Delší než nejdelší článek z TOP 10',
            description: 'Toto je volitelné doporučení, ne nutná podmínka. Delší text může pomoci u prvních pozic, ale článek natahujte jen tehdy, když to dává smysl. Aktuální délka článku je {0} slov',
            green: 'Více než {1} slov',
            yellow: 'Méně než {1} slov — volitelné doporučení',
            red: 'Méně než {1} slov',
        },
        keywordInIntroduction: {
            label: 'Klíčové slovo v prvním odstavci',
            description: '"{1}" v prvním odstavci',
            green: 'Použito',
            red: '"Chybí',
        },
        keywordInH1: {
            label: 'Klíčové slovo v nadpisu H1',
            description: '"{1}" v nadpisu H1',
            green: 'Použito',
            red: '"Chybí',
        },
        keywordInH2: {
            label: 'Klíčové slovo v nadpisu H2',
            description: '"{1}" v nadpisu H2',
            green: 'Použito',
            red: '"Chybí',
        },
        keywordInH3: {
            label: 'Klíčové slovo v nadpisu H3',
            description: '"{1}" v nadpisu H3',
            green: 'Použito',
            red: '"Chybí',
        },
        relatedKeywords: {
            label: 'Další relevantní klíčová slova',
            description: 'Do nadpisů a odstavců článku zapracujte také další související klíčová slova, která naleznete v analýze klíčových slov. {0} dalších relevantních klíčových slov použito v článku',
            green: 'Alespoň polovina',
            red: 'Méně než polovina',
        },
        inboundLinks: {
            label: 'Interní odkazy',
            description: 'Do textu odstavců vložte několik interních linků vedoucích na vaše články s podobnou tématikou nebo vysvětlující pojmy v něm použité. Odkazy na vlastní stránky: {0}',
            green: 'Alespoň jeden odkaz',
            red: 'Žádné odkazy',
        },
        outboundLinks: {
            label: 'Externí odkazy',
            description: 'Ujistěte se, že textu článku obsahuje několik linků na weby (které nejsou vašimi konkurenty) se zajímavým a kvalitním obsahem. Odkazy na cizí stránky: {0}',
            green: 'Alespoň jeden odkaz',
            red: 'Žádné odkazy',
        },
        inspirationFromTopTen: {
            label: 'Inspirace z TOP 10 konkurenčních článků',
            description: 'Obohaťte váš článek informacemi z nejlépe optimalizovaných webů. Stačí kliknout na "Inspirace z TOP obsahu" pod každým nadpisem či odstavcem.',
            green: 'Inspirace z TOP 10 konkurenčních článků',
            red: 'Bez inspirace',
        },
        subHeadingDistribution: {
            label: 'Nadpisy dílčích částí článku',
            description: 'Pro snadnější čtení obsahu článku je důležité používat podnadpisy, které oddělí text dlouhých odstavců. Nadpis má {0} z {1} částí',
            green: 'Všechny vyplněné',
            red: 'Některé chybí',
        },
        paragraphLength: {
            label: 'Délka odstavců',
            description: 'Pro snadnější čtení obsahu článku jsou důležité krátké odstavce. Poměr krátkých odstavců (<150 slov) je {0}',
            green: 'Většina odstavců je krátká',
            yellow: 'Alespoň polovina odstavců je krátká',
            red: 'Odstavce jsou dlouhé',
        },
        sentenceLength: {
            label: 'Průměrná délka vět',
            description: 'Krátkě věty usnadňují a zrychlují čtení a pochopení obsahu článku. Průměrná délka věty je {0} slov',
            green: 'Méně než {1} slov',
            yellow: 'Méně než {2} slov',
            red: 'Více než než {2} slov',
        },
        detail: {
            title: 'SEOWRITEE faktory SEO analýzy',
            subtitle: 'Vylepšit zapíše jen bezpečnou mechaniku. Textové faktory otevřou editor — šablony do článku se nevkládají.',
            openPage: 'Vylepšit SEO skóre',
            needsOptimization: 'Vyžaduje optimalizaci',
            canImprove: 'Lze zlepšit',
            lookingGood: 'Dobré skóre',
            filterAll: 'Všechny',
            filterGreen: 'Splněno',
            filterYellow: 'Upozornění',
            filterRed: 'Kritické',
            words: 'Slov: {0}',
            readTime: 'Čas: ~{0} min',
            categoriesLabel: 'Kategorie faktorů',
            categories: {
                all: 'Všechny faktory',
                ai: 'AI viditelnost',
                eeat: 'E-E-A-T',
                schema: 'Schema Markup & AI',
                headings: 'H1 & Nadpisy',
                serp: 'SERP Snippet & Meta',
                keywords: 'Klíčová slova & LSI',
                content: 'Obsah & FAQ',
                readability: 'Čtivost & Struktura',
                images: 'Obrázky & Alt',
                links: 'Odkazy & Záměr',
            },
            geoTitle: 'SEO & AI (GEO) optimalizace',
            geoBody: 'Skóre 1–100 % hodnotí Schema.org JSON-LD, odhad AI viditelnosti (GEO), E-E-A-T, hustotu klíčových slov a čtivost.',
            improve: 'Vylepšit',
            ok: 'OK',
            improveAll: 'Vylepšit vše ({0})',
            close: 'Zavřít',
            celebrate: 'Oslavit skóre',
            celebrateToast: 'Skvělé SEO skóre — článek je připravený k publikaci.',
            applied: 'Úprava se zapsala do článku',
            appliedAll: 'Dostupné úpravy se zapsaly do článku',
            editorHint: 'Tento faktor upravte v editoru článku',
            lucyHint: 'Otevřete editor — AI Lucy má tento faktor doplnit v textu, šablona se nevkládá',
            emptyTitle: 'Nejdřív otevřete článek',
            emptyBody: 'Detailní SEO skóre počítá faktory z aktuálního článku. Otevřete článek a odtud přejděte sem z levého menu nebo horní lišty.',
            openArticles: 'Přejít na články',
            noFactors: 'V tomto filtru teď nic není.',
            introSentence: 'Téma {0} je podstatné hned v úvodu článku.',
            faqQuestion: 'Co je {0}?',
            faqAnswer: '{0} je hlavní téma tohoto článku. Doplňte sem konkrétní, užitečnou odpověď.',
            internalLinkLabel: 'související článek',
            ai: {
                summary: 'Odhadovaná AI viditelnost je {0} %. U tématu „{1}“ rozhoduje konverzační FAQ, JSON-LD, konkrétní čísla a přímé odpovědi — stejně u nového článku i u analýzy z URL.',
                platformsTitle: 'Odhadovaná viditelnost podle platformy',
                factorsTitle: 'Klíčové faktory pro viditelnost v AI chatech (generativních vyhledávačích)',
                modeWrite: 'Měření z textu, který píšete: FAQ, schema, fakta, odkazy a přímá odpověď v úvodu.',
                modeAnalyze: 'Měření z obsahu staženého z URL: stejné on-page signály plus HTTPS a stáří textu.',
                directAnswer: 'Přímá odpověď: {0} je hlavní téma tohoto článku a čtenář by měl podstatu pochopit hned v úvodu.',
                factSentence: 'V číslech: u tématu {0} dává smysl opřít se o 10+ srovnání a ověřených údajů.',
                platforms: {
                    googleAio: 'AI Overviews',
                    chatgpt: 'ChatGPT',
                    perplexity: 'Perplexity',
                    copilot: 'Copilot',
                },
                factors: {
                    faq: {
                        title: 'Otázky a odpovědi (FAQ blok)',
                        ok: 'V článku je alespoň jedna otázka s odpovědí — v sekci FAQ, nebo jako nadpis ve formě otázky. Chatovací AI z takového bloku bere hotovou citaci.',
                        fail: 'Chybí pár otázka + odpověď. Přidejte FAQ sekci. Jde o strukturu Q&A, kterou AI chaty citují, ne o to, zda úvod sedí na klíčové slovo.',
                    },
                    schema: {
                        title: 'Strukturovaná data Schema.org',
                        ok: 'JSON-LD je v článku a pomáhá AI extrahovat význam stránky.',
                        fail: 'Bez FAQPage / BlogPosting schema mají AI systémy horší šanci článek citovat.',
                    },
                    facts: {
                        title: 'Faktický konkrétní obsah',
                        ok: 'V textu jsou čísla, roky nebo srovnání, které AI rády citují.',
                        fail: 'Doplňte konkrétní čísla, srovnání nebo definice k tématu {0}.',
                    },
                    outbound: {
                        title: 'Autoritativní zpětné odkazy',
                        ok: 'Článek cituje externí zdroj, což zvyšuje důvěryhodnost pro AI.',
                        fail: 'Přidejte odkaz na důvěryhodný zdroj — Perplexity a Copilot z citací vycházejí.',
                    },
                    freshness: {
                        title: 'Aktuálnost obsahu',
                        ok: 'Text působí aktuálně (letošní rok nebo nedávno uložený článek).',
                        fail: 'Aktualizujte fakta a datum — AI modely preferují novější zdroje.',
                    },
                    answers: {
                        title: 'Přímá odpověď na hledaný dotaz',
                        ok: 'H1 nebo úvod pokrývá klíčové slovo, případně na něj míří otázka v článku — AI může citovat první odpověď na „{0}“.',
                        fail: 'Úvod zatím neodpovídá na hledaný dotaz „{0}“. Dejte téma do H1 nebo první věty. To je jiný signál než FAQ blok na konci článku.',
                    },
                }
            },
            eeat: {
                intro: 'Co je E-E-A-T? Experience, Expertise, Authoritativeness, Trustworthiness — čtyři pilíře hodnocení kvality obsahu Googlem. Pro YMYL témata zvlášť kritické.',
                signalsTitle: 'Detailní hodnocení E-E-A-T signálů',
                actionsTitle: 'Doporučení pro okamžitou akci',
                experienceHeading: 'Zkušenosti z praxe',
                experienceBody: 'V praxi jsme {0} ověřili na konkrétních případech: zaznamenali jsme postup, limity i výsledek, aby čtenář viděl první ruku zkušenost, ne jen obecný popis.',
                modeWrite: 'U nového článku hodnotíme on-page signály (praxe v textu, hloubka, citace, schema). Signály webu jako HTTPS se započítají, jakmile doplníte URL.',
                modeAnalyze: 'U analýzy z URL započítáváme i HTTPS a stáří staženého obsahu, nejen to, co je v editoru.',
                pillars: {
                    experience: {name: 'Experience', hint: 'Přímá zkušenost'},
                    expertise: {name: 'Expertise', hint: 'Odbornost obsahu'},
                    authoritativeness: {name: 'Authoritativeness', hint: 'Autorita zdroje'},
                    trustworthiness: {name: 'Trustworthiness', hint: 'Důvěryhodnost'},
                },
                signals: {
                    reviews: {
                        title: 'Reálné reference a praxe',
                        ok: 'Text obsahuje zkušenost, recenzi nebo test, což signalizuje první ruku zkušenost.',
                        fail: 'Doplňte recenzi, test nebo „ověřili jsme v praxi“ u tématu {0}.',
                    },
                    author: {
                        title: 'Autorsky podepsaný obsah',
                        ok: 'Článek má jmenovaného autora v sekci Autor a E-E-A-T.',
                        fail: 'Doplňte jméno autora v sekci před snippetem — Google si cení konkrétní odborníky.',
                    },
                    authorBio: {
                        title: 'Odborné bio autora',
                        ok: 'U autora je bio s praxí nebo rolí, takže Expertise je čitelná.',
                        fail: 'Dopište krátké bio autora — kdo je a proč je k tématu kompetentní.',
                    },
                    freshDate: {
                        title: 'Viditelné datum obsahu',
                        ok: 'Článek má datum zveřejnění nebo aktualizace.',
                        fail: 'Doplňte datum aktualizace, ať je vidět, že obsah žije.',
                    },
                    specialization: {
                        title: 'Oborová specializace',
                        ok: 'Článek má podnadpisy a dostatek rozsahu, takže nepůsobí jako obecný text.',
                        fail: 'Rozšiřte strukturu H2 a délku, ať je vidět specializace na {0}.',
                    },
                    depth: {
                        title: 'Hloubka odborného obsahu',
                        ok: 'Rozsah a podnadpisy stačí na odborné pokrytí tématu.',
                        fail: 'Doplňte hlubší kapitoly, srovnání nebo postup — povrchní text E-E-A-T nesplní.',
                    },
                    mentions: {
                        title: 'Odkazy a zmínky',
                        ok: 'Článek obsahuje interní nebo externí odkazy, které posilují autoritu.',
                        fail: 'Přidejte citaci nebo interní odkaz — autorita se bez zmínek špatně prokazuje.',
                    },
                    citations: {
                        title: 'Zpětné odkazy z oborových zdrojů',
                        ok: 'V článku je externí citace, kterou lze brát jako oporu tvrzení.',
                        fail: 'Citujte důvěryhodný zdroj k tématu {0}.',
                    },
                    https: {
                        title: 'HTTPS a technická důvěra',
                        ok: 'URL je HTTPS, nebo u nového článku ještě není publikovaná — tento signál neblokuje.',
                        fail: 'Publikujte článek na HTTPS. U analýzy z URL bez HTTPS klesá důvěryhodnost.',
                    },
                    transparency: {
                        title: 'Transparentnost a důvěryhodné údaje',
                        ok: 'Text nebo schema obsahují důvěryhodné údaje (zdroj, podmínky, kontaktní stopy).',
                        fail: 'Doplňte zdroj, podmínky nebo schema — bez nich je Trustworthiness slabší.',
                    },
                }
            },
            status: {
                green: 'Splněno',
                yellow: 'Upozornění',
                red: 'Kritická chyba',
            },
            tips: {
                aiVisibility: 'Doplňte citovatelnou pasáž, FAQ z obsahu a schema. Šablonová věta do úvodu se nevkládá.',
                eeatScore: 'U nového článku doplňte praxi z briefingu. U článku z URL vyplňte autora, datum a bio v sekci před snippetem.',
                eatAuthor: 'Doplňte jméno autora. U článku z URL ho načteme z originálu.',
                eatDate: 'Doplňte datum zveřejnění nebo aktualizace.',
                eatBio: 'Napište dvě věty o praxi autora — posiluje to Expertise.',
                schemaMarkup: 'Při vylepšení se do kódu vloží JSON-LD podle obsahu článku (Article a FAQ, jen když FAQ existuje).',
                faqPresent: 'Přidejte alespoň jednu otázku s odpovědí — do FAQ sekce, nebo jako nadpis ve formě otázky v textu.',
                keywordVariants: 'Přidejte do článku alespoň 2–3 varianty klíčového slova z našeptávače.',
                keywordInSlug: 'URL má obsahovat slova klíčového výrazu. Pořadí, mezislova ani koncové lomítko nerozhodují.',
                imgAltIncludesKeyword: 'Doplňte do článku obrázek s popiskem ALT obsahujícím klíčové slovo.',
                titleIncludesKeyword: 'Dejte hlavní klíčové slovo ideálně na začátek meta title.',
                titleLength: 'Zkraťte meta title na doporučenou délku, ať se v SERP neořízne.',
                descriptionIncludesKeyword: 'Do meta description vložte hlavní klíčové slovo.',
                descriptionLength: 'Zkraťte meta description na doporučenou délku.',
                keywordDensity: 'Upravte výskyt klíčového slova, ať zůstane v doporučeném rozmezí hustoty.',
                serpIsComplete: 'Vyplňte meta title i meta description, aby byl SERP snippet kompletní.',
                avgWordCountOfTopTen: 'Dopište článek alespoň na průměrnou délku TOP 10 výsledků.',
                longestWordCountOfTopTen: 'Delší text než nejdelší článek z TOP 10 je volitelné doporučení. Následujte ho jen tehdy, když delší článek stále dává smysl.',
                keywordInIntroduction: 'Použijte hlavní klíčové slovo v prvním odstavci.',
                keywordInH1: 'Vložte hlavní klíčové slovo do nadpisu H1.',
                keywordInH2: 'Použijte klíčové slovo alespoň v jednom nadpisu H2.',
                keywordInH3: 'Použijte klíčové slovo alespoň v jednom nadpisu H3.',
                relatedKeywords: 'Zapracujte související klíčová slova z analýzy do nadpisů a odstavců.',
                inboundLinks: 'Vložte interní odkaz na související stránku na vašem webu.',
                outboundLinks: 'Přidejte odkaz na důvěryhodný externí zdroj (ne na konkurenci).',
                inspirationFromTopTen: 'Pod nadpisem otevřete inspiraci z TOP obsahu a doplňte chybějící témata.',
                subHeadingDistribution: 'Každá část s textem by měla mít podnadpis — oddělí dlouhé odstavce.',
                paragraphLength: 'Rozdělte odstavce delší než 150 slov, ať se text lépe čte.',
                sentenceLength: 'Zkraťte věty pod 20 slov, ať je článek srozumitelnější.',
            }
        }
    },

    articleTable: {
        selectedKeyword: 'Hlavní klíčové slovo',
        url: {
            header: {
                text: 'URL adresa zveřejněného článku',
                tooltip: 'Zadejte adresu URL článku a zjistěte organickou pozici na Googlu a SEO skóre domény.'
            },
            dialog: {
                title: {
                    add: 'Přidat URL',
                    edit: 'Upravit URL',
                },
                placeholder: 'https://www.odkaz.cz/cesta-k-clanku',
                errors: {
                    couldNotSave: 'Nepodařilo se uložit URL článku, zkuste to prosím znovu.',
                }
            },
            tooltip: {
                add: 'Přidat URL článku',
                edit: 'Upravit URL článku',
            }
        },
        createdAt: 'Vytvořen',
        position: {
            found: '✅ <strong>Nalezeno!</strong> Vaše stránka je použita jako <strong>zdroj</strong> v AI odpovědi',
            notFound: '❌ <strong>Nenalezeno</strong>. Vaše stránka nebyla v AI odpovědi citována',
            sourcePosition: "<strong>Pozice zdroje</strong>: Jste zobrazen jako <strong>{0}. zdroj (odkaz)</strong>",
            citedTitle: "Citovaný titulek",
            citedText: "Citovaný text",
        },
        organicPosition: {
            header: 'Pozice ve vyhledávání Google',
            tooltip: 'Zjistěte pozici článku v organických výsledcích vyhledávání na Googlu. Tato informace má pouze informativní charakter a nezaručuje skutečnou pozici článku.'
        },
        googleAIOPosition: {
            header: 'Pozice v Google AI Overview',
            tooltip: 'Zjistěte pozici článku v organických výsledcích vyhledávání na Googlu AI. Tato informace má pouze informativní charakter a nezaručuje skutečnou pozici článku.'
        },
        chatGPTPosition: {
            header: 'Pozice v ChatGPT odpovědích',
            tooltip: 'Zjistěte pozici článku ve výsledcích vyhledávání ChatGPT. Tato informace má pouze informativní charakter a nezaručuje skutečnou pozici článku.'
        },
        reloadableChip: {
            remeasure: 'Přeměřit',
            cooldown: 'Přeměření je možné za {0} hodin a {1} minut',
            errors: {
                unexpectedError: 'Nastala neočekávaná chyba, zkuste to prosím znovu.',
            },
            error: "Chyba",
        },
        seoScore: 'SEO skóre článku',
        domainSeoScore: {
            header: {
                text: 'SEO skóre domény',
                tooltip: 'Zjistěte SEO skóre domény, na které je článek zveřejněný.',
            },
            tooltip: 'Otevřít v novém okně',
        },
        edit: 'Vylepšit článek',
    },

    articleCrossroad: {
        newContent: {
            header: 'Nový obsah',
            description: 'Vytváření nového obsahu pro web nebo blog',
            button: 'Vytvořit nový obsah',
        },
        existingContent: {
            header: 'Existující obsah',
            description: 'Zlepšení obsahu zveřejněného na adrese URL',
            button: 'Analyzovat existující obsah',
        }
    },

    inspirationsError: {
        title: 'Nastala chyba při načítání inspirací.',
    },

    clipboardError: {
        title: 'Chyba při kopírování do schránky.',
    },

    stripeError: {
        title: 'Chyba při komunikaci s platební bránou.',
    },

    errors: {
        requiredField: "Toto pole musíte vyplnit.",
        maxWords: "Maximální délka je {0} slov!",
        minLength: "Délka musí být alespoň {length} znaků.",
        startsWithProtocol: "URL musí začínat http:// nebo https://",
        invalidUrl: "Neplatná URL adresa",
    },

    themeCustomizer: {
        title: 'Nastavení vzhledu',
        subtitle: 'Upravte a ihned si prohlédněte změny',
        theming: 'Vzhled',
        primaryColor: 'Hlavní barva',
        theme: 'Režim',
        skin: 'Styl karet',
        reset: 'Obnovit výchozí',
        customColor: 'Vlastní barva',
        colors: {
            blue: 'SEOWRITEE modrá',
            green: 'SEOWRITEE zelená',
            violet: 'Fialová',
            cyan: 'Tyrkysová',
            orange: 'Oranžová',
            red: 'Červená',
        },
        themes: {
            light: 'Světlý',
            dark: 'Tmavý',
            system: 'Podle systému',
        },
        skins: {
            default: 'Výchozí',
            bordered: 'S ohraničením',
        },
    },

    share: {
        copy: 'Sdílet náhled',
        copied: 'Odkaz zkopírován',
        tooltip: 'Pošlete odkaz komukoli. Uvidí článek 1:1, menu půjde proklikávat, živé funkce zůstanou vypnuté.',
        copiedTitle: 'Odkaz na náhled je ve schránce',
        copiedBody: 'Příjemce uvidí analyzovaný článek. Generování, analýza a úpravy v náhledu neběží.',
        errorTitle: 'Odkaz se nepodařilo vytvořit',
        errorBody: 'Zkuste to znovu, nebo článek nejdřív uložte.',
        bannerTitle: 'Toto je sdílený náhled článku',
        bannerBody: 'Vidíte analyzovaný článek 1:1. SEO menu vlevo můžete proklikávat. Generování, analýza, ukládání a AI Lucy jsou vypnuté.',
        drawerHint: 'Živé funkce v náhledu neběží. Vlastní článek spustíte po registraci.',
        register: 'Registrovat a zkusit na vlastním článku',
        openOwn: 'Zpět do mých článků',
        missingTitle: 'Tento náhled už není dostupný',
        missingBody: 'Odkaz je neplatný, nebo ho autor zrušil. Vytvořte si účet a zanalyzujte vlastní článek.',
        revoke: 'Zrušit sdílení',
        revokeConfirmTitle: 'Zrušit sdílený odkaz?',
        revokeConfirmBody: 'Odkaz, který jste poslali, přestane fungovat. Nový odkaz vytvoříte tlačítkem Sdílet náhled.',
        revokeConfirm: 'Zrušit odkaz',
        revokeCancel: 'Ponechat',
        revokedTitle: 'Sdílení je zrušené',
        revokedBody: 'Starý odkaz už nefunguje.',
        revokeErrorTitle: 'Sdílení se nepodařilo zrušit',
        revokeErrorBody: 'Zkuste to za chvíli znovu.',
    },

    loginMenu: {
        intro: 'Prohlédněte si, jak článek skóruje pro vyhledávače i AI chaty — ještě než se přihlásíte.',
        scoreHint: 'Skóre ukáže, co v článku chybí. Klikněte na barvu a na faktor.',
        factorHint: 'Po přihlášení vás AI Lucy dovede na místo v editoru.',
        lucyTitle: 'AI Lucy',
        lucyBody: 'Z živých AI odpovědí sestaví, co v článku chybí k citaci. U každého faktoru ukáže další krok.',
        stepsTitle: 'Od briefu po export',
        briefTitle: 'Brief a šablona pro AI',
        briefBody: 'Téma, trh a šablona: Google AI Overviews, Gemini, ChatGPT, Perplexity nebo Copilot. AI Lucy k tomu přidá podotázky a fakta k citaci.',
        keywordsTitle: 'Klíčová slova i otázky z AI',
        keywordsBody: 'Fráze z vyhledávání, otázky z AI Overviews a chatů, long-tail a obtížnost. Vyberete, co článek ponese.',
        writingTitle: 'Text, který jde citovat',
        writingBody: 'Přímá odpověď, FAQ, E-E-A-T a odhad AI viditelnosti. Pak export do DOCX nebo HTML.',
        samples: {
            1: 'pokladní systém',
            2: 'gastro pokladna',
            3: 'EET pokladna',
        },
        cta: 'Přihlásit se a vyzkoušet',
    },

    lucy: {
        name: 'AI Lucy',
        ask: 'Zeptat se AI Lucy',
        askMore: 'Zeptat se AI Lucy',
        askAbout: 'Vysvětlení od AI Lucy',
        goThere: 'Přejít',
        goToNamed: 'Přejít na: {0}',
        presetsLabel: 'AI Lucy se teď může zeptat',
        presets: {
            next: 'Co mám teď opravit?',
            aiVisibility: 'Vysvětli odhad AI viditelnosti',
            redList: 'Které faktory jsou kritické?',
            cite: 'Co napsat, aby text citovala AI?',
        },
        contextLine: 'Skóre {0} % · {1} kritických',
        noArticle: 'Otevřete článek, ať AI Lucy vidí kontext',
        helloEmpty: 'Otevřete článek. Pak vám řeknu, co v něm nejvíc zvedne SEO a AI viditelnost.',
        helloDone: 'Skóre {0} %. Nic kritického — můžete článek doladit a publikovat.',
        helloWork: 'Skóre {0} %. Nejbližší krok: {1}.',
        redListBody: 'Kritické teď jsou: {0}. Začněte prvním — AI Lucy vás tam dovede.',
        noReds: 'Žádné kritické faktory. Můžete doladit upozornění, nebo článek publikovat.',
        done: '{0} už článek splňuje. AI Lucy tu teď nemá co doplňovat.',
        phaseNote: 'AI Lucy píše texty podle zadání a analýz a zároveň je vaše průvodkyně v článku. Poradí, co nejvíc zvedne SEO skóre a AI viditelnost, a ukáže místo v editoru.',
        nudgeTitle: 'AI Lucy doporučuje',
        nudgeBody: 'Další krok: {0}',
        coach: {
            aiVisibility: {
                body: 'Odhad AI viditelnosti nespravíte jednou větou v úvodu. První nesplněný bod je: {0}. Tam to teď nejvíc zvedne šanci, že článek někdo cituje.',
                ok: 'FAQ, schema, autor, úvod i odkazy pro AI viditelnost sedí. AI Lucy tu teď nemá co přednostně opravit.',
            },
            faqPresent: 'Doplňte aspoň jednu otázku a odpověď. AI Overviews berou FAQ jako citovatelnou pasáž — víc než delší úvod.',
            faqFromBrief: 'Z živých AI otázek teď pokryjte aspoň: {0}. Krátká odpověď v FAQ se cituje líp než delší úvod.',
            introFromBrief: 'Úvod přepište jako přímou odpověď, kterou AI teď dává ve vyhledávání — první 40–60 slov, konkrétní fakta, žádná vata.',
            citeEmpty: 'Až AI Lucy stáhne živé odpovědi AI chatů, řekne vám, které otázky a entity do článku patří. Zatím doplňte FAQ s přímou odpovědí.',
            citeBody: 'Aby článek šel citovat v AI chatech: odpovězte na {0}. Pojmenujte entity {1}. Úvod musí stát sám o sobě jako citovatelná pasáž.',
            citeNoQuestions: 'otázky z AI Overview a chatu',
            citeNoEntities: 'konkrétní názvy, produkty a metody',
            schemaMarkup: 'JSON-LD se nevkládá do viditelného textu. Vylepšit ho zapíše do kódu. Prohlédnout ho můžete v náhledu na záložce Schema.',
            eatAuthor: 'Podepište autora před snippetem. Google i AI odpovědi berou jméno jako signál, že text někdo garantuje.',
            eatDate: 'Doplňte datum zveřejnění nebo aktualizace. Bez data vypadá článek jako neudržovaný.',
            eatBio: 'Napište dvě věty o praxi autora. Krátké bio posílí E-E-A-T víc než obecná fráze v úvodu.',
            eeatScore: 'E-E-A-T tady drží autor, datum, bio a důvěryhodné odkazy. Začněte jménem autora, pokud chybí.',
            keywordInIntroduction: 'Hlavní klíčové slovo patří do prvního odstavce, ať je hned jasné, na co článek odpovídá.',
            keywordInH1: 'Do nadpisu H1 teď hlavní klíčové slovo chybí. Doplňte ho, ideálně na začátek.',
            keywordInH2: 'Klíčové slovo zatím není v žádném nadpisu H2. Použijte ho aspoň v jednom.',
            keywordInH3: 'Klíčové slovo zatím není v žádném nadpisu H3. Použijte ho aspoň v jednom.',
            outboundLinks: 'Vložte odkaz na důvěryhodný zdroj v textu článku — ne do bloku tipů dole. Odkaz na konkurenci vynechte.',
            inboundLinks: 'Vložte interní odkaz na související stránku vašeho webu přímo do odstavce.',
            keywordVariants: 'Varianty najdete v analýze ve sloupci související. Vyberte 2–3 a zapracujte je do nadpisů nebo odstavců.',
            keywordDensity: 'Hustotu ladíte v levém menu u klíčových slov. Příliš málo i příliš moc výskytů škodí stejně.',
            serpIsComplete: 'Snippet vzniká z meta title a description. Vyplňte obojí — náhled pod poli ukáže, jak to uvidí Google.',
            imgAltIncludesKeyword: 'Doplňte popisek obrázku (alt) s klíčovým slovem. Prázdný alt Google i čtečka přeskočí.',
            keywordInSlug: 'URL by měla obsahovat hlavní klíčové slovo. U zveřejněné stránky počítejte s přesměrováním.',
        },
    },

    topBar: {
        articles: 'Články & měření',
        articlesLine1: 'Články',
        articlesLine2: 'a měření',
        saveLine1: 'Uložit',
        saveLine2: 'článek',
        detailedSeoScore: 'Vylepšit SEO skóre',
        seoParams: 'SEO Parametry',
        thisArticle: 'Tento článek',
        manual: 'Manuál',
        blog: 'Blog',
        promo: 'Domluvte si schůzku',
        settingsTooltip: 'Nastavení plochy',
    },
    checkOutFeatures: "Podívejte se, s čím vším vám SEOWRITEE pomůže!",

    aiBrief: {
        title: 'Zadání z odpovědí AI chatů',
        subtitle: 'Tvar odpovědi a živé odpovědi AI chatů, podle kterých AI Lucy napíše citovatelný článek. LSI slova jsou ve variantách, otázky v analýze klíčových slov.',
        loading: 'AI Lucy stahuje, jak na tohle téma teď odpovídá vyhledávání a AI chaty…',
        loadingAria: 'Načítání…',
        loadingMore: 'Doplňuji živé odpovědi AI chatů…',
        loadingHeader: 'Doplňuji záměr a tvar odpovědi…',
        empty: 'K tomuto tématu zatím nemáme živé odpovědi AI chatů. Článek můžete vygenerovat z vybraných klíčových slov.',
        emptyLiveAnswer: 'Z tohoto AI chatu zatím nemáme živou odpověď.',
        connectionError: 'Nepodařilo se spojit se službou pro živé odpovědi AI chatů (chyba připojení nebo oprávnění). Zkuste stránku znovu načíst.',
        keepShape: 'Použít tvar při psaní',
        keepShapeOn: 'Tvar se použije při psaní',
        keepShapeTip: 'Uloží pokyn pro AI Lucy, ať článek píše v tomto tvaru (definice, kroky, seznam…). Text v editoru se nepřepíše.',
        keepShapeOnTip: 'Pokyn už platí: AI Lucy bude držet tento tvar. Další klik článek nepřepíše.',
        intentTip: 'Zjištěný záměr hledání, podle kterého AI Lucy staví článek.',
        shapeChipTip: 'Tvar odpovědi, jak na dotaz teď odpovídá vyhledávání a AI chaty.',
        templateChipTip: 'Šablona struktury, kterou má AI Lucy teď nastavenou.',
        useOverviewTemplate: 'Psát jako AI Overview',
        useOverviewTemplateTip: 'Nastaví šablonu AI Overviews a pokyn držet tvar odpovědi. Text z karty se do článku nevloží.',
        useGeminiTemplate: 'Psát jako Gemini',
        useGeminiTemplateTip: 'Nastaví šablonu Gemini a pokyn držet tvar odpovědi. Text z karty se do článku nevloží.',
        usePerplexityTemplate: 'Psát jako Perplexity',
        usePerplexityTemplateTip: 'Nastaví šablonu Perplexity, pokyn držet tvar odpovědi a skočí na H2, ať fakta zkontrolujete vy. Text z karty se nevloží.',
        useChatGptTone: 'Použít tón ChatGPT',
        useChatGptToneTip: 'Nastaví tón ChatGPT (přátelský a srozumitelný) pro AI Lucy. Stažený článek se nepřepíše a text z karty se nevloží.',
        lsiInserted: 'Vybraná LSI slova jsou v úvodu a v seznamu hustoty.',
        nothingToInsert: 'Vybrané pojmy už v textu jsou.',
        avatarTooltip: 'Tlačítko s avatarem otevře panel AI Lucy.',
        avatarAria: 'Otevřít panel AI Lucy',
        inH2: 'už jako H2',
        factInserted: 'Věta je v úvodu článku',
        factExists: 'Toto už v článku je — skočili jsme na místo',
        headingInIntro: 'Téma je zapracované v úvodu',
        headingAdded: 'Přidali jsme nadpis H2',
        headingExists: 'Tento H2 už v článku je',
        shapeKept: 'Tvar odpovědi se použije při psaní. Stažený článek se nepřepsal.',
        templateAndShapeApplied: 'Šablona je nastavená a AI Lucy použije tvar odpovědi při psaní. Stažený článek se nepřepsal.',
        layerLive: 'Živé odpovědi AI chatů',
        layerKeywords: 'Klíčová slova',
        answersHint: 'Tlačítko "Zapracovat informace" vloží fakta do článku, nevloží celý obsah',
        expandAnswer: 'Zobrazit celou odpověď',
        collapseAnswer: 'Sbalit',
        toH2: 'Přidat H2',
        toH2Tip: 'Tlačítko "Přidat H2" přidá otázku jako nadpis H2 v editoru a zaškrtne ji pro AI Lucy. Když už tam je, skočí na ni.',
        toFaq: 'Přidat FAQ',
        toFaqTip: 'Tlačítko "Přidat FAQ" přidá otázku do FAQ v editoru a zaškrtne ji pro AI Lucy.',
        inFaq: 've FAQ',
        inFaqTip: 'Otázka už je ve FAQ. Kliknutím ji z FAQ odeberete.',
        inH2Tip: 'Tento H2 už v článku je. Klik skočí na to místo.',
        addToText: 'Doplnit do textu',
        addToTextTip: 'AI Lucy zapracuje pojem do existujících částí bez nového podnadpisu — nepočítá se do 20 odstavců.',
        alreadyInIntro: 'už v úvodu',
        alreadyInIntroTip: 'Pojem už v článku je. Klik ho znovu nevloží.',
        workIn: 'Zapracovat informace',
        workInTip: 'Tlačítko "Zapracovat informace" vloží fakta do článku, nevloží celý obsah',
        workedIn: 'Zapracováno',
        workedInTip: 'Informace z této odpovědi už jsou v článku zapracované.',
        workInDone: 'Zapracovali jsme fakta z této odpovědi do článku. Celý přepis se nevložil.',
        workInNothing: 'V této odpovědi jsme nenašli nová fakta, která v článku ještě nejsou.',
        useTemplateTip: 'Přepne šablonu struktury článku na doporučenou. Text v editoru se nepřepíše.',
        expandAnalysisTip: 'Otevře skupiny klíčových slov. Otázky jsou ve skupině Otázky, LSI ve skupině Varianty a LSI.',
        collapseAnalysisTip: 'Sbalí tabulky klíčových slov.',
        keepTone: 'Použít tón ChatGPT',
        checkFacts: 'Psát jako Perplexity',
        templateUsed: 'použito',
        recommended: 'Doporučeno',
        expandAnalysis: 'Rozbalit analýzu',
        collapseAnalysis: 'Sbalit analýzu',
        analysisMeta: '{0} skupiny · {1}/{2} pro AI Lucy · sbaleno',
        analysisMetaOpen: '{0} skupiny · {1}/{2} pro AI Lucy',
        toneApplied: 'Tón je nastavený. Stažený článek zůstává, dokud neproběhne Vylepšit nebo ruční úprava.',
        templateHint: 'Podle intentu a AI odpovědí AI Lucy doporučuje šablonu {0}.',
        useTemplate: 'Použít šablonu',
        intent: {
            informational: 'Záměr: vysvětlit',
            navigational: 'Záměr: najít konkrétní místo',
            commercial: 'Záměr: porovnat a vybrat',
            transactional: 'Záměr: jednat / koupit',
        },
        shape: {
            definition: 'Tvar výsledku: definice',
            steps: 'Tvar výsledku: kroky',
            list: 'Tvar výsledku: seznam',
            table: 'Tvar výsledku: tabulka',
            comparison: 'Tvar výsledku: srovnání',
        },
        platforms: {
            googleAio: 'AI Overview',
            chatgpt: 'ChatGPT',
            gemini: 'Gemini',
            claude: 'Claude',
            perplexity: 'Perplexity',
        },
        sources: {
            paa: 'z vyhledávání',
            related: 'související',
            fanout: 'podotázka',
            mentions: 'z AI chatu',
            forums: 'diskuze',
            labs: 'návrh',
            lsi: 'LSI',
            pas: 'PAS',
            organicFaq: 'z webu TOP',
            autocomplete: 'dopisování',
        },
        citedSources: 'Zdroje, které AI cituje',
        citedSourcesHint: 'Odkazy, které AI chaty použily jako zdroje. Vyberte je pro AI Lucy — zmíní je jako outbound citace (E-E-A-T).',
        citeForLucy: 'Vybrat pro AI Lucy',
        citeForLucyTip: 'Tlačítko "Pro AI Lucy" přidá tento zdroj do zadání jako volitelnou outbound citaci.',
        citedSelected: 'zmínit jako zdroj',
        citedSelectedTip: 'Tento zdroj AI Lucy zmíní jako citaci. Kliknutím výběr zrušíte.',
        insertHint: 'vložit nápověď do FAQ',
        insertHintTip: 'Vloží nápověď z People also ask do odpovědi FAQ. Do článku se bez kliknutí nedá.',
    },
};
